import React, { useState, useEffect, useContext, useRef } from "react";
import BarChartLoader from "./barChartLoader";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Container } from "react-bootstrap";
import styles from "./styles.module.css";
import NumericLoader from "./numericLoader";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  Rectangle,
  Label,
  LineChart,
  Line,
  Tooltip,
} from "recharts";
import {
  DatePicker,
  Button,
  Input,
  Space,
  Select,
  Divider,
  Radio,
  ConfigProvider,
  Switch,
  Checkbox,
  Modal,
  Tooltip as AntTooltip,
} from "antd";
import { BreathAPIs } from "../../../APIs/BreathAPIs";
import { FaFilter } from "react-icons/fa6";
import { BiSolidLeftArrow } from "react-icons/bi";
import { IoMdCloseCircle } from "react-icons/io";
import { CiCircleInfo } from "react-icons/ci";
import dayjs from "dayjs";
import { FaDotCircle } from "react-icons/fa";
import { AiFillThunderbolt } from "react-icons/ai";
import { HiUsers } from "react-icons/hi2";
import { FaChargingStation } from "react-icons/fa";
import { PiPlugsConnectedBold } from "react-icons/pi";
import { FaClock } from "react-icons/fa";
import TooltipView from "./TooltipView";
import {toast, ToastContainer } from "react-toastify";
import { MdAttachMoney } from "react-icons/md";
import { FaDownload } from "react-icons/fa";
import * as XLSX from "xlsx";
import Dashboard from "../../Dashboard";

// import { RechartsDevtools } from '@recharts/devtools';

const AdminDashboard = ({ user, type, userGroups }) => {
  const [monthlyRevenueData, setMonthlyRevenueData] = useState(null);
  const [isMUFGraphVisible, setIsMUFGraphVisible] = useState(false)
  const [monthlyRevenueDataPerCharger, setMonthlyRevenueDataPerCharger] = useState(null);
  const [monthlyUtilizationRevenueDataPerUserState, setMonthlyUtilizationRevenueDataPerUserState] = useState(null);
  const [monthlyCreditRevenuePerUser, setMonthlyCreditRevenuePerUser] = useState(null);
  const [showPerChargerData, setShowPerChargerData] = useState(false);
  const [showTotalRevenueData, setShowTotalRevenueData] = useState(false);
  const [totalRevenueData, setTotalRevenueData] = useState(null);
  const [totalSharedRevenue, setTotalSharedRevenue] = useState(null);
  const [totalEnergyConsumptionData, setTotalEnergyConsumption] =
    useState(null);
  const [monthlyEnergyConsumptionData, setMonthlyEnergyConsumption] =
    useState(null);
  const [monthlyUtilization, setMonthlyUtilization] = useState(null);
  const [monthlyUptime, setMonthlyUptime] = useState(null);
  const [averageBookingDuration, setAverageBookingDuration] = useState(null);
  const [totalUniqueUsers, setTotalUniqueUsers] = useState(null);
  const [averageDayUtilization, setAverageDayUtilization] = useState(null);
  const [dayOfWeekUtilization, setDayOfWeekUtilization] = useState(null);
  const [chargerCount, setChargerCount] = useState(0)
  const [connectorCount, setConnectorCount] = useState(0)
  const [filterFromDate, setFilterFromDate] = useState(
    new Date(
      new Date(
        new Date(
          new Date(new Date().setHours(23, 59, 59, 999)).getTime()
        ).setMonth(
          new Date(
            new Date(new Date().setHours(23, 59, 59, 999)).getTime()
          ).getMonth() - 6
        )
      ).setHours(0, 0, 0, 0)
    )
  );
  const [userFilterLocationIdState, setUserFilterLocationIdsState] = useState(null)
  const [filterToDate, setFilterToDate] = useState(
    new Date(new Date().setHours(23, 59, 59, 999))
  );
  const [locationsData, setLocationsData] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [location, setLocation] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [
    isPublicLocationSelectedInFilter,
    setIsPublicLocationSelectedInFilter,
  ] = useState(false);

  const [breatheRevenueData, setBreatheRevenueData] = useState([0, 0, 0, 0]);
  const [totalCustomerRevenue, setTotalCustomerRevenue] = useState(0);
  const [totalBreatheRevenue, setTotalBreatheRevenue] = useState(0);
  const [totalTransactionFee, setTotalTransactionFee] = useState(0);

  const [currentDashboard, setCurrentDashboard] = useState(
    "Location Level Dashboard"
  );
  const [adminCredits, setAdminCredits] = useState({
    adminCredits: [],
    totalAdminCredits: 0,
  });
  const [activeUsers, setActiveUsers] = useState(null);
  const [secondaryActiveUsers, setSecondaryActiveUsers] = useState(null);
  const [registeredUsers, setRegisteredUsers] = useState(null);
  const [totalRegisteredUsers, setTotalRegisteredUsers] = useState(0);
  const [usersRegisteredButNeverCharged, setUsersRegisteredButNeverCharged] =
    useState(null);
  const [windowDashboardSelector, setWindowDashboardSelector] = useState(null);
  const [selectedTimeZone, setSelectedTimeZone] = useState("UTC");
  const [refundData, setRefundData] = useState(0);
  const [averageChargingSpeed, setAverageChargingSpeed] = useState(null)
  const [monthlyCumulativeCharger, setMonthlyCumulativeCharger] = useState([])
  const [monthlyCumulativeUsers, setMonthlyCumulativeUsers] = useState([])
  const [monthlyCumulativeLocations, setMonthlyCumulativeLocations] = useState([])
  const [isSessionReportVisible, setIsSessionReportVisible] = useState(false)
  const [showReportDownloadModal, setShowReportDownloadModal] = useState(false)
  const [reportFilterFromDate, setReportFilterFromDate] = useState(null)
  const [reportFilterToDate, setReportFilterToDate] = useState(null)
  const [selectedLocationForReport, setSelectedLocationForReport] = useState(null)
  const [isExcelDownloading, setIsExcelDownloading] = useState(false);


  useEffect(() => {
    userGroups.filter((userGroup) => {
      try {

        let parsedPermissions = JSON.parse(userGroup.permissions)
        // console.log("parsedPermissions : ", parsedPermissions)

        try {
          if (parsedPermissions?.sessionReportAllowed && parsedPermissions?.sessionReportAllowed === 'yes') {
            setIsSessionReportVisible(true)
          }
        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        console.log(error);
      }
    })
  }, [userGroups]);

  useEffect(() => {
    getLocationsData();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
        setShowFilters(false);
      }
    };
    const handleInnerWidth = () => {
      if (window.innerWidth > 767) {
        setWindowDashboardSelector(true);
      } else {
        setWindowDashboardSelector(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleInnerWidth);

    handleInnerWidth();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleInnerWidth);
    };
  }, []);

  useEffect(() => {
    // console.log("calling apis on selected time zone change : ", selectedTimeZone);
    // getDashboardData();
    getDashboardRevenueData();
    // getMonthlyCreditRevenuePerUser();
    getDashboardEnergyConsumptionData();
    getDashboardUtilizationData();
    getDashboardBookingDurationData();
    getDashboardUsersData();
    getDashboardDayUtilizationData();
    getDashboardUptimeData();
    getDashboardAdminCredits();
    getDashboardActiveUsers();
    getDashboardSecondaryActiveUsers();
    getDashboardRegisteredUsersData();
    getDashboardTotalRegisteredUsers();
    getUsersRegisteredButNeverCharged();
    getMonthlyCumulativeUserAndCharger();
    getChargerCount();
    getDayOfWeekUtilizationData();
    getDashboardBookingRefundData();
    getDashboardAverageChargingSpeed()
  }, [filterFromDate, filterToDate, location, selectedTimeZone]);

  const [loading, setIsLoading] = useState({
    DashboardRevenueData: false,
    DashboardEnergyConsumptionData: false,
    DashboardUtilizationData: false,
    DashboardBookingDurationData: false,
    DashboardUsersData: false,
    DashboardDayUtilizationData: false,
    DashboardUptimeData: false,
    DashboardAdminCredits: false,
    DashboardActiveUsers: false,
    DashboardSecondaryActiveUsers: false,
    DashboardRegisteredUsers: false,
    DashboardTotalRegisteredUsers: false,
    DashboardUsersRegisteredButNeverCharged: false,
    getChargerCount: false,
    DashboardDayOfWeekUtilizationData: false,
    DashboardAverageChargingSpeed: false,
    sessionReport: false
  });

  const getDashboardBookingRefundData = async () => {
    try {
      const bookingRefundsData = await BreathAPIs.getBookingRefunds(
        filterFromDate,
        filterToDate,
        location ? location : null,
        selectedTimeZone
      )
      // console.log("bookingRefundsData: ", bookingRefundsData.data);
      setRefundData(bookingRefundsData.data.totalRefund ? bookingRefundsData.data.totalRefund : 0);
    } catch (error) {
      console.log("Error while retrieving dashboard booking refund data", error);
    }
  }

  // const getMonthlyCreditRevenuePerUser = async () => {
  //   try{
  //     const res = await BreathAPIs.getMonthlyCreditRevenuePerUser( filterFromDate, filterToDate);
  //     console.log("monthly credit revenue per user data: ", res.data);
  //     setMonthlyCreditRevenuePerUser(res.data);
  //   }catch(error){
  //     console.log("Error while retrieving monthly credit revenue per user data", error.message);
  //   }
  // }
  const getDashboardRevenueData = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, DashboardRevenueData: true }));
      // console.log("before revenue api call")
      const res = await BreathAPIs.getDashboardRevenueData(
        filterFromDate,
        filterToDate,
        location ? location : null,
        selectedTimeZone
      );

      const creditRevenue = await BreathAPIs.getMonthlyCreditRevenuePerUser(filterFromDate, filterToDate);
      // console.log("credit revenue data: ", creditRevenue.data);
      // console.log("after revenue api call")
      // console.log("res: ", res.data.data);

      let revenueDataForGraph = [];
      let revenueDataForGraphPerCharger = []
      let monthlyUtilizationRevenueDataPerUser = []
      let breatheRevenueData = [0, 0, 0, 0, 0]; // [RevShareTotalRevenue, BreatheMiscRevenue, PerPortRevenue, taxCost, MUF] (RevShareTotalRevenue=totalcustomer revenue + breathe shared revenue)
      let totalCustomerRevenue = 0;
      let totalBreatheRevenue = 0;
      let totalTransactionFee = 0;
      // console.log("res.data.monthlyUserCount : ", res.data.monthlyUserCount);
      let monthlyCumulativeUserCount = {}
      res.data.monthlyUserCount.forEach((item) => {
        monthlyCumulativeUserCount[item._id] = item.cumulativeUsers
      });

      // console.log("monthlyCumulativeUserCount", monthlyCumulativeUserCount)
      Object.keys(res.data.data).forEach((key) => {
        totalCustomerRevenue += res.data.data[key].TotalCustomerRevenue;
        totalTransactionFee += res.data.data[key].TotalTransactionFee || 0;
        breatheRevenueData[0] =
          breatheRevenueData[0] + res.data.data[key].RevShareTotalRevenue;
        breatheRevenueData[1] =
          breatheRevenueData[1] + res.data.data[key].BreatheMiscRevenue;
        breatheRevenueData[2] =
          breatheRevenueData[2] + res.data.data[key].PerPortRevenue;
        breatheRevenueData[3] =
          breatheRevenueData[3] + res.data.data[key].TaxCost;
        breatheRevenueData[4] =
          breatheRevenueData[4] + res.data.data[key].MUFRevenue;
        // console.log("keys", key)
        // console.log("user count per month", res.data.monthlyUserCount)
        monthlyUtilizationRevenueDataPerUser.push({
          _id: key,
          utilizationRevenuePerUser: Number((Number((res.data.data[key].RevShareTotalRevenue + res.data.data[key].BreatheMiscRevenue)) / Number(monthlyCumulativeUserCount[key])).toFixed(2)),
          creditRevenuePerUser: creditRevenue.data.filter((item) => {
            return item._id === key
          })[0]?.revenuePerUser ?? 0
        })
        // totalRevShareRevenue += res.data.data[key].RevShareTotalRevenue
        revenueDataForGraphPerCharger.push({
          _id: key,
          taxCost: (Number(res.data.data[key].TaxCost) / res.data.data[key].ChargerCount).toFixed(2),
          breathePerPortRevenue: (Number(
            res.data.data[key].PerPortRevenue
          ) / res.data.data[key].ChargerCount).toFixed(2),
          totalCustomerRevenue: (Number(
            res.data.data[key].TotalCustomerRevenue
          ) / res.data.data[key].ChargerCount).toFixed(2),
          breatheRevShareRevenue: (Number(
            (
              res.data.data[key].RevShareTotalRevenue -
              res.data.data[key].TotalCustomerRevenue
            )
          ) / res.data.data[key].ChargerCount).toFixed(2),
          breatheMiscRevenue: (Number(
            res.data.data[key].BreatheMiscRevenue
          ) / res.data.data[key].ChargerCount).toFixed(2),
          breatheTotalRevenue: (Number(
            (
              res.data.data[key].RevShareTotalRevenue -
              res.data.data[key].TotalCustomerRevenue +
              res.data.data[key].PerPortRevenue +
              res.data.data[key].BreatheMiscRevenue
            )
          ) / res.data.data[key].ChargerCount).toFixed(2),
          breatheMUFRevenue: (Number(
            res.data.data[key].MUFRevenue.toFixed(2)
          ) / res.data.data[key].ChargerCount).toFixed(2),
          transactionFee: (Number(
            res.data.data[key].TotalTransactionFee || 0
          ) / res.data.data[key].ChargerCount).toFixed(2),
        });
        revenueDataForGraph.push({
          _id: key,
          taxCost: Number(res.data.data[key].TaxCost.toFixed(2)),
          breathePerPortRevenue: Number(
            res.data.data[key].PerPortRevenue.toFixed(2)
          ),
          totalCustomerRevenue: Number(
            res.data.data[key].TotalCustomerRevenue.toFixed(2)
          ),
          breatheRevShareRevenue: Number(
            (
              res.data.data[key].RevShareTotalRevenue -
              res.data.data[key].TotalCustomerRevenue
            ).toFixed(2)
          ),
          breatheMiscRevenue: Number(
            res.data.data[key].BreatheMiscRevenue.toFixed(2)
          ),
          breatheMUFRevenue: Number(
            res.data.data[key].MUFRevenue.toFixed(2)
          ),
          breatheTotalRevenue: Number(
            (
              res.data.data[key].RevShareTotalRevenue -
              res.data.data[key].TotalCustomerRevenue +
              res.data.data[key].PerPortRevenue +
              res.data.data[key].BreatheMiscRevenue +
              res.data.data[key].MUFRevenue
            ).toFixed(2)
          ),
          transactionFee: Number(
            (res.data.data[key].TotalTransactionFee || 0).toFixed(2)
          ),
        });
      });
      // console.log("revenueDataForGraph 1", revenueDataForGraph);
      totalBreatheRevenue =
        breatheRevenueData[0] -
        totalCustomerRevenue +
        breatheRevenueData[1] +
        breatheRevenueData[2] +
        breatheRevenueData[4];
      // revenueDataForGraph.push({_id: '03-26', totalRevenue: '0.00', totalCustomerRevenue: 700})
      // console.log("total customer revenue: ", totalCustomerRevenue)
      // console.log("revenueDataForGraph", revenueDataForGraph);
      // console.log("monthlyUtilizationRevenueDataPerUser", monthlyUtilizationRevenueDataPerUser);
      // console.log("revenueDataForGraph", revenueDataForGraph);
      setMonthlyRevenueData(revenueDataForGraph);
      setMonthlyRevenueDataPerCharger(revenueDataForGraphPerCharger)
      setMonthlyUtilizationRevenueDataPerUserState(monthlyUtilizationRevenueDataPerUser)
      setTotalCustomerRevenue(totalCustomerRevenue);
      setTotalBreatheRevenue(totalBreatheRevenue);
      setTotalTransactionFee(totalTransactionFee);
      setBreatheRevenueData(breatheRevenueData);
      // console.log('monthly revenue data: ',revenueDataForGraph);

      // setTotalRevenueData(totalRevShareRevenue);
      // setTotalSharedRevenue(totalCustomerRevenue);
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, DashboardRevenueData: false }));
    }
  };

  const getDashboardAdminCredits = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, DashboardAdminCredits: true }));
      // console.log("before revenue api call")
      const res = await BreathAPIs.getDashboardAdminCredits(
        filterFromDate,
        filterToDate
      );
      // console.log("after revenue api call")
      // console.log("admin credits : ", res.data.data)
      setAdminCredits(res.data.data);
      setIsLoading((prev) => ({ ...prev, DashboardAdminCredits: false }));
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, DashboardAdminCredits: false }));
      // setIsLoading((prev) => ({ ...prev, DashboardRevenueData: false }));
    }
  };

  const getDashboardActiveUsers = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, DashboardActiveUsers: true }));

      const res = await BreathAPIs.getDashboardActiveUsers(
        filterFromDate,
        filterToDate
      );
      // console.log("after revenue api call")
      // console.log("Active Users Data : ", res.data.data)
      setActiveUsers(res.data.data);

      setIsLoading((prev) => ({ ...prev, DashboardActiveUsers: false }));
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      // setIsLoading((prev) => ({ ...prev, DashboardRevenueData: false }));
      setIsLoading((prev) => ({ ...prev, DashboardActiveUsers: false }));
    }
  };

  const getDashboardSecondaryActiveUsers = async () => {
    try {
      setIsLoading((prev) => ({
        ...prev,
        DashboardSecondaryActiveUsers: true,
      }));

      const res = await BreathAPIs.getDashboardSecondaryActiveUsers(
        filterFromDate,
        filterToDate
      );
      // console.log("after revenue api call")
      // console.log("Active Users Data : ", res.data.data)
      setSecondaryActiveUsers(res.data.data);
      setIsLoading((prev) => ({
        ...prev,
        DashboardSecondaryActiveUsers: false,
      }));
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({
        ...prev,
        DashboardSecondaryActiveUsers: false,
      }));
      // setIsLoading((prev) => ({ ...prev, DashboardRevenueData: false }));
    }
  };

  const getDashboardRegisteredUsersData = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, DashboardRegisteredUsers: true }));

      const res = await BreathAPIs.getDashboardRegisteredUsersData(
        filterFromDate,
        filterToDate
      );
      // console.log("after revenue api call")
      // console.log("Registered Users Data : ", res.data.data)
      setRegisteredUsers(res.data.data);
      setIsLoading((prev) => ({ ...prev, DashboardRegisteredUsers: false }));
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, DashboardRegisteredUsers: false }));
      // setIsLoading((prev) => ({ ...prev, DashboardRevenueData: false }));
    }
  };

  const getDashboardTotalRegisteredUsers = async () => {
    try {
      setIsLoading((prev) => ({
        ...prev,
        DashboardTotalRegisteredUsers: true,
      }));

      const res = await BreathAPIs.getDashboardTotalRegisteredUsers(
        filterFromDate,
        filterToDate
      );
      // console.log("after revenue api call")
      // console.log("Total Registered Users : ", res.data.data)
      setTotalRegisteredUsers(res.data.data);
      setIsLoading((prev) => ({
        ...prev,
        DashboardTotalRegisteredUsers: false,
      }));
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({
        ...prev,
        DashboardTotalRegisteredUsers: false,
      }));
      // setIsLoading((prev) => ({ ...prev, DashboardRevenueData: false }));
    }
  };

  useEffect(()=>{
    if(userFilterLocationIdState){
      getMonthlyCumulativeUserAndCharger()
    }

  },[userFilterLocationIdState])

  const formattedDateForZeroUser =  (now)=>{ 
    return new Intl.DateTimeFormat('en-GB', {
  month: '2-digit',
  year: 'numeric'
}).format(now).replace('/', '-')};

  const getMonthlyCumulativeUserAndCharger = async () => {
    try {
      let response = await BreathAPIs.getMonthlyChargerAndUser(
        filterToDate,
       (userFilterLocationIdState && userFilterLocationIdState.length > 0) ? [userFilterLocationIdState] : []
      )
      

      let filteredChargers = response?.data?.cumulativeCharger || [];
      let filteredUsers = (response?.data?.cumulativeUser.length > 0 ? response?.data?.cumulativeUser : [{_id: formattedDateForZeroUser(new Date()), monthlyRegisteredUsers: 0, cumulativeUsers: 0}]) || [];
      let filteredLocations = response?.data?.cumulativeLocation || [];

      if (filterFromDate) {
        const fromDateObj = new Date(filterFromDate);
        const fromMonth = (fromDateObj.getMonth() + 1).toString().padStart(2, '0');
        const fromYear = fromDateObj.getFullYear().toString();
        const filterFromStr = `${fromYear}${fromMonth}`;

        filteredChargers = filteredChargers.filter(item => {
          if (!item._id || !item._id.includes('-')) return true;
          const [mm, yyyy] = item._id.split('-');
          return `${yyyy}${mm}` >= filterFromStr;
        });

        filteredUsers = filteredUsers.filter(item => {
          if (!item._id || !item._id.includes('-')) return true;
          const [mm, yyyy] = item._id.split('-');
          return `${yyyy}${mm}` >= filterFromStr;
        });

        filteredLocations = filteredLocations.filter(item => {
          if (!item._id || !item._id.includes('-')) return true;
          const [mm, yyyy] = item._id.split('-');
          return `${yyyy}${mm}` >= filterFromStr;
        });
      }

      setMonthlyCumulativeCharger(filteredChargers)
      setMonthlyCumulativeUsers(filteredUsers)
      setMonthlyCumulativeLocations(filteredLocations)
    } catch (error) {
      console.log("error in fetching cumulative charger and user: ", error.message)
    }
  }

  const getUsersRegisteredButNeverCharged = async () => {
    try {
      setIsLoading((prev) => ({
        ...prev,
        DashboardUsersRegisteredButNeverCharged: true,
      }));

      const res = await BreathAPIs.getUsersRegisteredButNeverCharged(
        filterFromDate,
        filterToDate
      );
      // console.log("after revenue api call")
      // console.log("getUsersRegisteredButNeverCharged : ", res.data.data)
      setUsersRegisteredButNeverCharged(res.data.data);
      setIsLoading((prev) => ({
        ...prev,
        DashboardUsersRegisteredButNeverCharged: false,
      }));
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({
        ...prev,
        DashboardUsersRegisteredButNeverCharged: false,
      }));

      // setIsLoading((prev) => ({ ...prev, DashboardRevenueData: false }));
    }
  };

  const getDashboardEnergyConsumptionData = async () => {
    try {
      setIsLoading((prev) => ({
        ...prev,
        DashboardEnergyConsumptionData: true,
      }));

      const res = await BreathAPIs.getDashboardEnergyConsumptionData(
        filterFromDate,
        filterToDate,
        location ? location : null,
        selectedTimeZone
      );
      setMonthlyEnergyConsumption(res.data.data.MonthlyEnergyConsumptionData);
      setTotalEnergyConsumption(res.data.data.TotalEnergyDelivered);
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({
        ...prev,
        DashboardEnergyConsumptionData: false,
      }));
    }
  };
  const getChargerCount = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, getChargerCount: true }));

      const res = await BreathAPIs.getChargerCount(location ? location : null);
      // console.log("charger count respone : ", res.data);
      setChargerCount(res.data.chargerCount)
      setConnectorCount(res.data.connectorCount)
      // setMonthlyUtilization(res.data.data.AverageDayUtilization);
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, getChargerCount: false }));
    }
  };

  const getDashboardUtilizationData = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, DashboardUtilizationData: true }));

      const res = await BreathAPIs.getDashboardUtilizationData(
        filterFromDate,
        filterToDate,
        location ? location : null,
        selectedTimeZone
      );
      setMonthlyUtilization(res.data.data.AverageDayUtilization);
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, DashboardUtilizationData: false }));
    }
  };

  const getDashboardBookingDurationData = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, DashboardBookingDurationData: true }));

      const res = await BreathAPIs.getDashboardBookingDurationData(
        filterFromDate,
        filterToDate,
        location ? location : null
      );
      setAverageBookingDuration(res.data.data.AverageBookingDuration);
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({
        ...prev,
        DashboardBookingDurationData: false,
      }));
    }
  };

  const getDashboardUsersData = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, DashboardUsersData: true }));

      const res = await BreathAPIs.getDashboardUsersData(
        filterFromDate,
        filterToDate,
        location ? location : null
      );
      setTotalUniqueUsers(res.data.data.TotalUniqueUsers);
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, DashboardUsersData: false }));
    }
  };
  const getDayOfWeekUtilizationData = async () => {
    try {
      setIsLoading((prev) => ({
        ...prev,
        DashboardDayOfWeekUtilizationData: true,
      }));

      const res = await BreathAPIs.getDayOfWeekUtilizationData(
        filterFromDate,
        filterToDate,
        location ? location : null
      );
      // console.log("res.data.dayUtilizationData ", res.data.dayUtilizationData);
      setDayOfWeekUtilization(res.data.dayUtilizationData);
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({
        ...prev,
        DashboardDayOfWeekUtilizationData: false,
      }));
    }
  };

  const getDashboardDayUtilizationData = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, DashboardDayUtilizationData: true }));

      const res = await BreathAPIs.getDashboardDayUtilizationData(
        filterFromDate,
        filterToDate,
        location ? location : null
      );
      setAverageDayUtilization(res.data.data);
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, DashboardDayUtilizationData: false }));
    }
  };

  const getDashboardUptimeData = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, DashboardUptimeData: true }));

      const res = await BreathAPIs.getDashboardUptimeData(
        filterFromDate,
        filterToDate,
        location ? location : null
      );
      setMonthlyUptime(res.data.data.MonthlyUptime);
    } catch (error) {
      console.log("Error while retrieving dashboard data", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, DashboardUptimeData: false }));
    }
  };

  const getLocationsData = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, DashboardUptimeData: true }));
      const res = await BreathAPIs.getDashboardFilterLocations();

      try {
        const hasMufType = res.data.locations.some((loc) =>
          loc.revenueModel?.some((model) => model.revenueType === 'muf')
        );

        if (hasMufType) {
          setIsMUFGraphVisible(true);
        }
      } catch (error) {
        console.error("Error in setting muf graph visibility: ", error.message);
      }
      let states = res.data.locations.map((location) => location.address.state);
      // console.log("locations data", res.data.locations);
      // console.log("states", states);
      states = [...new Set(states)];
      setStates(states);
      setLocationsData(res.data.locations);
      location === null
        ? setIsPublicLocationSelectedInFilter(
          res.data.locations.some((location) => location.public)
        )
        : console.log("");
    } catch (error) {
      console.log("Error while retrieving locations data", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, DashboardUptimeData: false }));
    }
  };

  const getDashboardAverageChargingSpeed = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, DashboardAverageChargingSpeed: true }))
      const res = await BreathAPIs.getDashboardAverageChargingSpeed(
        filterFromDate,
        filterToDate,
        location ? location : null,
        selectedTimeZone
      );
      setAverageChargingSpeed(res.data.data);

    } catch (error) {
      console.log('Error while retrieving average charging speed', error)
    }
    finally {
      setIsLoading((prev) => ({ ...prev, DashboardAverageChargingSpeed: false }))
    }
  }

  const Counter = ({ target }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      const increment = target / 100; // Adjust the speed of the counter by changing the divisor
      const interval = setInterval(() => {
        setCount((prevCount) => {
          const nextCount = prevCount + increment;
          if (nextCount >= target) {
            clearInterval(interval);
            return target;
          }
          return nextCount;
        });
      }, 1); // Adjust the timing for faster or slower counting

      return () => clearInterval(interval);
    }, []);

    return count;
  };

  let setLocationForFilter = (location=[], state=null) => {
    console.log("setLocationForFilter called with location:", location, "and state:", state);
    if(state){
      let stateLocations = locationsData.filter((loc) => loc.address.state === state);
      let stateLocationIds = stateLocations.map((loc) => loc._id);
      
      setLocation(stateLocationIds.length > 0 ? stateLocationIds : null);
    }else{
      setLocation(location.length > 0 ? location : null);
    }
    
    // console.log("location", location)
    const hasPublic =
      location.length > 0
        ? location.some((id) => {
          const location = locationsData.find((loc) => loc._id === id);
          return location && location.public;
        })
        : locationsData.some((location) => location.public);
    hasPublic
      ? setIsPublicLocationSelectedInFilter(true)
      : setIsPublicLocationSelectedInFilter(false);
    // console.log("public location in selected array", hasPublic)
  };

  const useResponsiveBarName = (fullName, shortName, breakpoint = 768) => {
    const [barName, setBarName] = useState(fullName);

    useEffect(() => {
      const updateBarName = () => {
        if (window.innerWidth < breakpoint) {
          setBarName(shortName);
        } else {
          setBarName(fullName);
        }
      };

      updateBarName(); // Set initial state based on current screen size
      window.addEventListener("resize", updateBarName); // Listen for screen size changes

      return () => {
        window.removeEventListener("resize", updateBarName); // Clean up listener
      };
    }, [fullName, shortName, breakpoint]);

    return barName;
  };
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className={`${styles["customTooltip"]}`}>
          <p className="label">{`${payload[0].name
            }: $${payload[0].value.toFixed(2)}`}</p>
        </div>
      );
    }
    return null;
  };

  const MonthlyLocationsTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const monthlyEntry = payload.find((p) => p.dataKey === "monthlyLocations");
      const cumulativeEntry = payload.find((p) => p.dataKey === "cumulativeLocations");
      const registeredLocationNames = payload[0]?.payload?.registeredLocationNames || [];
      return (
        <div className={styles["locationsTooltip"]}>
          <p className={styles["locationsTooltipMonth"]}>{label}</p>
          {monthlyEntry && <p>New Locations: {monthlyEntry.value}</p>}
          {cumulativeEntry && <p>Cumulative Locations: {cumulativeEntry.value}</p>}
          {registeredLocationNames.length > 0 && (
            <>
              <p className={styles["locationsTooltipListTitle"]}>Locations Added:</p>
              <ul className={styles["locationsTooltipList"]}>
                {registeredLocationNames.map((name, idx) => (
                  <li key={idx}>{name}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      );
    }
    return null;
  };

  const data2 = [
    {
      name: "BreatheEV Share",
      value: totalRevenueData
        ? parseFloat(totalRevenueData - totalSharedRevenue)
        : 0,
    },
    {
      name: "Your Share",
      value: totalSharedRevenue ? parseFloat(totalSharedRevenue) : 0,
    },
  ];
  // console.log("data2", data2)
  const formatDate = (date) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const dateToConvert = new Date(date);
    const month = months[dateToConvert.getMonth()];
    const day = dateToConvert.getDate();
    const year = dateToConvert.getFullYear();
    return `${month} ${day} ${year}`;
  };
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const { RangePicker } = DatePicker;
  const COLORS = ["#309f40", "#18365E"];
  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.62;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        fontSize="x-small"
        // textAnchor={x > cx ? 'start' : 'end'}
        textAnchor="middle"
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  // console.log(monthlyUptime)
  const renderFomratter = (value, entry) => {
    const { color } = entry;

    return <span style={{ fontSize: "12px" }}>{value}</span>;
  };

  // Returns { divisor, unit } for the Energy Consumption chart
  const getEnergyUnit = (data) => {
    const maxKwh = data && data.length
      ? data.reduce((acc, curr) => {
          const v = parseFloat(curr.EnergyConsumption) || 0;
          return v > acc ? v : acc;
        }, 0)
      : 0;
    // console.log("maxKwh value: ", maxKwh)
    if (maxKwh >= 1000000) return { divisor: 1000000, unit: 'GWh' };
    if (maxKwh >= 10000)    return { divisor: 1000,     unit: 'MWh' };
    return { divisor: 1, unit: 'kWh' };
  };

  const disableFutureDates = (current) => {
        return current && current > new Date(); // Disable dates after today
      };

      function toLocalISOString(date) {
        const pad = (num) => String(num).padStart(2, '0');
    
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
    
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
    }

const jsonToCsv = (json,reportType) => {

        if(reportType === 'sessionReport'){

            const headers = Object.keys(json[0]);
            const csvRows = [];
        
           
            csvRows.push(headers.join(','));
        
      
            for (const row of json) {
                
              const values = headers.map(header => {
                // let value = row[header];
                // if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
                //     // Ensure it preserves the full format
                //     value = new Date(value).toISOString().replace('T', ' ').slice(0, 19);
                // }
                let escaped = ('' + row[header]).replace(/"/g, '\\"');
                return header === "Interval Data" ? `"${escaped.replace(/,/g,":")}"` : `${escaped}`;
              });
              csvRows.push(values.join(','));
            }
        
            return csvRows.join('\n');
        }
        if(reportType === 'downtimeReport'){
            

            let csvContent = "";
        
           
            csvContent += "ChargerID,OfflineTimestamp,DownTimeDuration,UpdatedBy,OnlineTimestamp\n";
        
            json.forEach((item) => {
                item.groupedDocuments.forEach((doc) => {
                    csvContent += `${doc.charger},${doc.offlineTimestamp},${doc.downTimeDuration},${doc.updatedBy},${doc.onlineTimestamp}\n`;
                });
            });
        
            // Add blank lines to separate the tables
            csvContent += "\n\n";
        
            // Add summary fields to the CSV
            csvContent += "Summary Fields\n";
            csvContent += "ChargerID,ChargerDowntimeCount,Downtime Duration (> 8 mins),Downtime Duration (5–8 Minutes),AverageDownTimeDuration,StandardDeviationDownTimeDuration\n";
        
            json.forEach((item) => {
                csvContent += `${item._id},${item.chargerDowntimeCount},${item.downtimeDurationRedWarning},${item.downtimeDurationYellowWarning},${item.averageDownTimeDuration},${item.standardDeviationDownTimeDuration}\n`;
            });

            return csvContent
        }
      };


const callSessionReportLambdaFunction = async () => {
        try {
            // setIsCSVLoading({...isCSVLoading,sessionReport:true})

           setIsLoading((prev) => ({ ...prev, sessionReport: true }))

        // console.log('filterfromdate:',filterFromDate);
        if(selectedLocationForReport == null || selectedLocationForReport == undefined ){
          setIsLoading((prev) => ({ ...prev, sessionReport: false }))
          return  toast.error('Please select a location');
        }
        if(reportFilterFromDate == null || reportFilterFromDate == undefined 
          // || reportFilterToDate == null || reportFilterToDate == undefined 
        ){
          setIsLoading((prev) => ({ ...prev, sessionReport: false }))
          return toast.error('Please select a month');
        }
        const startDate = new Date(reportFilterFromDate);
        // console.log("filterFromDate",filterFromDate)
        startDate.setDate(1);
        startDate.setHours(0,0,0,0);

        // const endDate = new Date(reportFilterToDate);
        // endDate.setHours(23,59,59,999);

        // console.log("start date: ",startDate);
     
        
        const tempendDate = new Date(reportFilterFromDate.$y, reportFilterFromDate.$M + 1 , 0).getDate();
        // console.log("tempendDate",tempendDate)
        const endDate = new Date(reportFilterFromDate.$y,reportFilterFromDate.$M,tempendDate);
        // console.log("endDate",endDate)
        endDate.setHours(23,59,59,999)
        // console.log("endDate after setting hours",endDate)
    
        
        // console.log('StartDate:',toLocalISOString(new Date(startDate)));
        // console.log('endDate:',toLocalISOString(new Date(endDate)));
        // console.log('Selected Location: ',selectedLocation._id);
        
        // const result = await BreathAPIs.getLambdaData(toLocalISOString(new Date(startDate)),toLocalISOString(new Date(endDate)),selectedLocationForReport,[], "Customer"); 
        const result = await BreathAPIs.getLocationSessionReportLambda(toLocalISOString(new Date(startDate)),toLocalISOString(new Date(endDate)),selectedLocationForReport); 
        console.log('Logging result',result);  
                
        if(result.data && result.data.length === 0){
            toast.warn('No data to process in this time frame');
            setIsLoading((prev) => ({ ...prev, sessionReport: false }))
            // setIsCSVLoading({...isCSVLoading,sessionReport:false})
            return;
        }
        if(result.status !== 200){
            toast.error('Error generating csv');
            setIsLoading((prev) => ({ ...prev, sessionReport: false }))
            // setIsCSVLoading({...isCSVLoading,sessionReport:false})
            return;
        }
        const csvResponse = jsonToCsv(result.data,'sessionReport');
        // console.log(JSON.stringify(result.data))
        // const csvResponse = result.data;
        //   const jsonString = JSON.stringify(result, null, 2); 
        //   const blob = new Blob([csvResponse], { type: 'text/csv' }); 
      
          // Create a download link and trigger the download
        //   const link = document.createElement('a');
        //   link.href = URL.createObjectURL(blob);
        //   link.download = `BEVLocationReport${new Date().toISOString()}`
        //   document.body.appendChild(link); 
        //   link.click(); 
        //   document.body.removeChild(link); 

        let reportLocationData = locationsData.filter((item)=>item._id === selectedLocationForReport)[0];
          const formattedDate = new Date().toISOString().split('T')[0].replace(/(\d{4})-(\d{2})-(\d{2})/, '$1-$3-$2');
          const blob = new Blob([csvResponse], { type: 'text/csv' });
          // const blob = new Blob(["\uFEFF" + csvResponse], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.setAttribute('href', url);
          a.setAttribute('download', `${reportFilterFromDate.$y}-${reportFilterFromDate.$M+1}_${reportLocationData.locationName}-SessionRecords.csv`);
          a.click();
          // setIsCSVLoading({...isCSVLoading,sessionReport:false})
          setIsLoading((prev) => ({ ...prev, sessionReport: false }))
      
        } catch (error) {
          setIsLoading((prev) => ({ ...prev, sessionReport: false }))
          console.error('Error calling AWS Lambda & report generation:', error);
          // setIsCSVLoading({...isCSVLoading,sessionReport:false})
        }
      };


  const downloadAllGraphsExcel = (graphData = null) => {
    try {
      setIsExcelDownloading(true);

      const formatMonthLabel = (value) => {
        if (!value || typeof value !== "string") return value || "";
        if (value.includes("-")) {
          const parts = value.split("-");
          const m = parseInt(parts[0], 10);
          if (!isNaN(m) && m >= 1 && m <= 12) {
            const yr = parts[1] ? (parts[1].length === 4 ? parts[1].slice(-2) : parts[1]) : "";
            return `${months[m - 1]}-${yr}`;
          }
        }
        return value;
      };

      const formatUptimeMonthLabel = (value) => {
        if (!value || typeof value !== "string") return value || "";
        if (value.includes("-")) {
          const temp = value.split("-");
          const m = parseInt(temp[1], 10);
          if (!isNaN(m) && m >= 1 && m <= 12) {
            return `${months[m - 1]}-${temp[0].slice(-2)}`;
          }
        }
        return value;
      };

      const autoFitColumns = (json, worksheet) => {
        if (!json || json.length === 0) return;
        const colWidths = Object.keys(json[0]).map((key) => {
          let maxLen = key.length;
          json.forEach((row) => {
            const val = row[key];
            const str = val !== null && val !== undefined ? String(val) : "";
            if (str.length > maxLen) maxLen = str.length;
          });
          return { wch: Math.min(Math.max(maxLen + 3, 12), 45) };
        });
        worksheet["!cols"] = colWidths;
      };

      const wb = XLSX.utils.book_new();
      let graphConfigs = []

      if(graphData == null){
        graphConfigs = [
          {
            sheetName: "Energy Consumption",
            data: monthlyEnergyConsumptionData,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "Energy Consumption (kWh)": item.EnergyConsumption != null ? parseFloat(Number(item.EnergyConsumption).toFixed(4)) : 0,
            }),
          },
          {
            sheetName: "Monthly Revenue",
            data: monthlyRevenueData,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "Total Customer Revenue ($)": item.totalCustomerRevenue != null ? Number(item.totalCustomerRevenue) : 0,
              "BEV MUF Revenue ($)": item.breatheMUFRevenue != null ? Number(item.breatheMUFRevenue) : 0,
              "BEV Per Port Revenue ($)": item.breathePerPortRevenue != null ? Number(item.breathePerPortRevenue) : 0,
              "BEV RevShare Revenue ($)": item.breatheRevShareRevenue != null ? Number(item.breatheRevShareRevenue) : 0,
              "BEV Misc Revenue ($)": item.breatheMiscRevenue != null ? Number(item.breatheMiscRevenue) : 0,
              "Tax Cost ($)": item.taxCost != null ? Number(item.taxCost) : 0,
              "Transaction Fee ($)": item.transactionFee != null ? Number(item.transactionFee) : 0,
              "BEV Total Revenue ($)": item.breatheTotalRevenue != null ? Number(item.breatheTotalRevenue) : 0,
            }),
          },
          {
            sheetName: "Revenue Per Charger",
            data: monthlyRevenueDataPerCharger,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "Total Customer Revenue ($)": item.totalCustomerRevenue != null ? Number(item.totalCustomerRevenue) : 0,
              "BEV MUF Revenue ($)": item.breatheMUFRevenue != null ? Number(item.breatheMUFRevenue) : 0,
              "BEV Per Port Revenue ($)": item.breathePerPortRevenue != null ? Number(item.breathePerPortRevenue) : 0,
              "BEV RevShare Revenue ($)": item.breatheRevShareRevenue != null ? Number(item.breatheRevShareRevenue) : 0,
              "BEV Misc Revenue ($)": item.breatheMiscRevenue != null ? Number(item.breatheMiscRevenue) : 0,
              "Tax Cost ($)": item.taxCost != null ? Number(item.taxCost) : 0,
              "Transaction Fee ($)": item.transactionFee != null ? Number(item.transactionFee) : 0,
              "BEV Total Revenue ($)": item.breatheTotalRevenue != null ? Number(item.breatheTotalRevenue) : 0,
            }),
          },
          {
            sheetName: "Monthly Utilization",
            data: monthlyUtilization,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "Utilization Percentage (%)": item.MonthUtilization != null ? parseFloat(Number(item.MonthUtilization).toFixed(2)) : 0,
            }),
          },
          {
            sheetName: "Monthly Uptime",
            data: monthlyUptime,
            mapFn: (item) => ({
              "Month": formatUptimeMonthLabel(item.month),
              "Uptime Percentage (%)": item.uptimePercentage != null ? parseFloat(Number(item.uptimePercentage).toFixed(2)) : 0,
            }),
          },
          {
            sheetName: "Time of Day Utilization",
            data: averageDayUtilization,
            mapFn: (item) => ({
              "Start Time": item.startTime || "",
              "Hour Utilization Percentage (%)": item.timeUtilisation != null ? parseFloat(Number(item.timeUtilisation).toFixed(2)) : 0,
            }),
          },
          {
            sheetName: "Day Wise Utilization",
            data: dayOfWeekUtilization,
            mapFn: (item) => ({
              "Day": item.day || "",
              "Day Utilization Percentage (%)": item.utilization != null ? parseFloat(Number(item.utilization).toFixed(2)) : 0,
            }),
          },
          {
            sheetName: "Avg Charging Speed",
            data: averageChargingSpeed,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "Average Charging Speed (kW)": item.averageChargingSpeed != null ? parseFloat(Number(item.averageChargingSpeed).toFixed(2)) : 0,
            }),
          },
          {
            sheetName: "Admin Credits",
            data: adminCredits?.adminCredits,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item.monthYear),
              "Admin Credits ($)": item.adminCredits != null ? parseFloat(Number(item.adminCredits).toFixed(2)) : 0,
            }),
          },
          {
            sheetName: "Revenue Per User",
            data: monthlyUtilizationRevenueDataPerUserState,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "Utilization Revenue Per User ($)": item.utilizationRevenuePerUser != null ? Number(item.utilizationRevenuePerUser) : 0,
              "Credited Revenue Per User ($)": item.creditRevenuePerUser != null ? Number(item.creditRevenuePerUser) : 0,
            }),
          },
          {
            sheetName: "Monthly Location Count",
            data: monthlyCumulativeLocations,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "New Locations": Number(item.monthlyLocations || 0),
              "Cumulative Locations": Number(item.cumulativeLocations || 0),
              "Locations Added": Array.isArray(item.registeredLocationNames) ? item.registeredLocationNames.join(", ") : (item.registeredLocationNames || ""),
            }),
          },
          {
            sheetName: "Monthly Charger Count",
            data: monthlyCumulativeCharger,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "New Chargers": Number(item.monthlyChargers || 0),
              "Cumulative Chargers": Number(item.cumulativeChargers || 0),
              "Chargers Added": Array.isArray(item.registeredChargerNames) ? item.registeredChargerNames.join(", ") : (item.registeredChargerNames || ""),
            }),
          },
          {
            sheetName: "Monthly User Count",
            data: monthlyCumulativeUsers,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "New Registered Users": Number(item.monthlyRegisteredUsers || 0),
              "Cumulative Users": Number(item.cumulativeUsers || 0),
            }),
          },
          {
            sheetName: "Registered Users",
            data: registeredUsers,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item.monthYear),
              "Registered Users": Number(item.registeredUsers || 0),
            }),
          },
          {
            sheetName: "Active Users 1",
            data: activeUsers,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item.monthYear),
              "Active Users Percentage (%)": item.activeUsersRatio != null ? parseFloat(Number(item.activeUsersRatio).toFixed(2)) : 0,
            }),
          },
          {
            sheetName: "Active Users 2",
            data: secondaryActiveUsers,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item.monthYear),
              "Active Users Percentage (%)": item.activeUsersRatio != null ? parseFloat(Number(item.activeUsersRatio).toFixed(2)) : 0,
            }),
          },
        ];
    }else if(graphData == 'Energy Consumption'){

      graphConfigs = [{
            sheetName: "Energy Consumption",
            data: monthlyEnergyConsumptionData,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "Energy Consumption (kWh)": item.EnergyConsumption != null ? parseFloat(Number(item.EnergyConsumption).toFixed(4)) : 0,
            }),
          }]

    }else if(graphData == "Monthly Revenue"){
      graphConfigs = [{
            sheetName: "Monthly Revenue",
            data: monthlyRevenueData,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "Total Customer Revenue ($)": item.totalCustomerRevenue != null ? Number(item.totalCustomerRevenue) : 0,
              "BEV MUF Revenue ($)": item.breatheMUFRevenue != null ? Number(item.breatheMUFRevenue) : 0,
              "BEV Per Port Revenue ($)": item.breathePerPortRevenue != null ? Number(item.breathePerPortRevenue) : 0,
              "BEV RevShare Revenue ($)": item.breatheRevShareRevenue != null ? Number(item.breatheRevShareRevenue) : 0,
              "BEV Misc Revenue ($)": item.breatheMiscRevenue != null ? Number(item.breatheMiscRevenue) : 0,
              "Tax Cost ($)": item.taxCost != null ? Number(item.taxCost) : 0,
              "Transaction Fee ($)": item.transactionFee != null ? Number(item.transactionFee) : 0,
              "BEV Total Revenue ($)": item.breatheTotalRevenue != null ? Number(item.breatheTotalRevenue) : 0,
            }),
          }]
    }else if(graphData == "Revenue Per Charger"){
      graphConfigs = [{
            sheetName: "Revenue Per Charger",
            data: monthlyRevenueDataPerCharger,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "Total Customer Revenue ($)": item.totalCustomerRevenue != null ? Number(item.totalCustomerRevenue) : 0,
              "BEV MUF Revenue ($)": item.breatheMUFRevenue != null ? Number(item.breatheMUFRevenue) : 0,
              "BEV Per Port Revenue ($)": item.breathePerPortRevenue != null ? Number(item.breathePerPortRevenue) : 0,
              "BEV RevShare Revenue ($)": item.breatheRevShareRevenue != null ? Number(item.breatheRevShareRevenue) : 0,
              "BEV Misc Revenue ($)": item.breatheMiscRevenue != null ? Number(item.breatheMiscRevenue) : 0,
              "Tax Cost ($)": item.taxCost != null ? Number(item.taxCost) : 0,
              "Transaction Fee ($)": item.transactionFee != null ? Number(item.transactionFee) : 0,
              "BEV Total Revenue ($)": item.breatheTotalRevenue != null ? Number(item.breatheTotalRevenue) : 0,
            }),
          }]
    }else if(graphData == "Monthly Utilization"){
      graphConfigs = [{
            sheetName: "Monthly Utilization",
            data: monthlyUtilization,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "Utilization Percentage (%)": item.MonthUtilization != null ? parseFloat(Number(item.MonthUtilization).toFixed(2)) : 0,
            }),
          }]
    }else if(graphData == "Monthly Uptime"){
      graphConfigs = [{
            sheetName: "Monthly Uptime",
            data: monthlyUptime,
            mapFn: (item) => ({
              "Month": formatUptimeMonthLabel(item.month),
              "Uptime Percentage (%)": item.uptimePercentage != null ? parseFloat(Number(item.uptimePercentage).toFixed(2)) : 0,
            }),
          }]
    }else if(graphData == "Time of Day Utilization"){
      graphConfigs = [{
            sheetName: "Time of Day Utilization",
            data: averageDayUtilization,
            mapFn: (item) => ({
              "Start Time": item.startTime || "",
              "Hour Utilization Percentage (%)": item.timeUtilisation != null ? parseFloat(Number(item.timeUtilisation).toFixed(2)) : 0,
            }),
          }]
    }else if(graphData == "Day Wise Utilization"){
      graphConfigs = [{
            sheetName: "Day Wise Utilization",
            data: dayOfWeekUtilization,
            mapFn: (item) => ({
              "Day": item.day || "",
              "Day Utilization Percentage (%)": item.utilization != null ? parseFloat(Number(item.utilization).toFixed(2)) : 0,
            }),
          }]
    }else if(graphData == "Avg Charging Speed"){
      graphConfigs = [{
            sheetName: "Avg Charging Speed",
            data: averageChargingSpeed,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "Average Charging Speed (kW)": item.averageChargingSpeed != null ? parseFloat(Number(item.averageChargingSpeed).toFixed(2)) : 0,
            }),
          }]
    }else if(graphData == "Admin Credits"){
      graphConfigs = [{
            sheetName: "Admin Credits",
            data: adminCredits?.adminCredits,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item.monthYear),
              "Admin Credits ($)": item.adminCredits != null ? parseFloat(Number(item.adminCredits).toFixed(2)) : 0,
            }),
          }]
    }else if(graphData == "Revenue Per User"){
      graphConfigs = [{
            sheetName: "Revenue Per User",
            data: monthlyUtilizationRevenueDataPerUserState,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "Utilization Revenue Per User ($)": item.utilizationRevenuePerUser != null ? Number(item.utilizationRevenuePerUser) : 0,
              "Credited Revenue Per User ($)": item.creditRevenuePerUser != null ? Number(item.creditRevenuePerUser) : 0,
            }),
          }]
    }else if(graphData == "Monthly Location Count"){
      graphConfigs = [{
            sheetName: "Monthly Location Count",
            data: monthlyCumulativeLocations,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "New Locations": Number(item.monthlyLocations || 0),
              "Cumulative Locations": Number(item.cumulativeLocations || 0),
              "Locations Added": Array.isArray(item.registeredLocationNames) ? item.registeredLocationNames.join(", ") : (item.registeredLocationNames || ""),
            }),
          }]
    }else if(graphData == 'Monthly Charger Count'){
      graphConfigs = [{
            sheetName: "Monthly Charger Count",
            data: monthlyCumulativeCharger,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "New Chargers": Number(item.monthlyChargers || 0),
              "Cumulative Chargers": Number(item.cumulativeChargers || 0),
              "Chargers Added": Array.isArray(item.registeredChargerNames) ? item.registeredChargerNames.join(", ") : (item.registeredChargerNames || ""),
            }),
          }]
    }else if(graphData == 'Monthly User Count'){
      graphConfigs = [ {
            sheetName: "Monthly User Count",
            data: monthlyCumulativeUsers,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item._id),
              "New Registered Users": Number(item.monthlyRegisteredUsers || 0),
              "Cumulative Users": Number(item.cumulativeUsers || 0),
            }),
          }]
    }else if(graphData == 'Registered Users'){
      graphConfigs = [{
            sheetName: "Registered Users",
            data: registeredUsers,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item.monthYear),
              "Registered Users": Number(item.registeredUsers || 0),
            }),
          }]
    }
    else if(graphData == 'Active Users 1'){
      graphConfigs = [{
            sheetName: "Active Users 1",
            data: activeUsers,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item.monthYear),
              "Active Users Percentage (%)": item.activeUsersRatio != null ? parseFloat(Number(item.activeUsersRatio).toFixed(2)) : 0,
            }),
          }]
    }
    else if(graphData == 'Active Users 2'){
      graphConfigs = [{
            sheetName: "Active Users 2",
            data: secondaryActiveUsers,
            mapFn: (item) => ({
              "Month": formatMonthLabel(item.monthYear),
              "Active Users Percentage (%)": item.activeUsersRatio != null ? parseFloat(Number(item.activeUsersRatio).toFixed(2)) : 0,
            }),
          }]
    }

      graphConfigs.forEach((cfg) => {
        const sheetRows =
          Array.isArray(cfg.data) && cfg.data.length > 0
            ? cfg.data.map(cfg.mapFn)
            : [{ "Status": "No data available in this time frame" }];
        const ws = XLSX.utils.json_to_sheet(sheetRows);
        autoFitColumns(sheetRows, ws);
        XLSX.utils.book_append_sheet(wb, ws, cfg.sheetName);
      });

      const fromStr = filterFromDate ? dayjs(filterFromDate).format("YYYY-MM-DD") : "start";
      const toStr = filterToDate ? dayjs(filterToDate).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
      const fileName = `BEV_Admin_Dashboard_Graphs_${fromStr}_to_${toStr}.xlsx`;

      XLSX.writeFile(wb, fileName);
      toast.success("Excel file downloaded successfully!");
    } catch (error) {
      console.error("Error generating Excel file:", error);
      toast.error("Failed to generate Excel file");
    } finally {
      setIsExcelDownloading(false);
    }
  };


  return (
    <Container>
      <ToastContainer></ToastContainer>
      <button
        onClick={() => {
          setShowFilters(!showFilters);
          setShowReportDownloadModal(false);
        }}
        className={`${styles["filter-button"]} ${
          scrolled ? styles["show"] : ""
        }`}
      >
        <FaFilter />
      </button>

      {isSessionReportVisible && (
        <button
          onClick={() => {
            setShowFilters(false);
            setShowReportDownloadModal(!showReportDownloadModal);
          }}
          className={`${styles["report-download-button"]}`}
        >
          {/* <FaFilter /> */}
          <FaDownload />
        </button>
      )}

      {(type === "Admin" || type === "Breathe-Admin") && (
        <AntTooltip title="Download All Graphs Data (Excel)" placement="right">
          <button
            onClick={()=>{downloadAllGraphsExcel()}}
            style={{
              marginTop: isSessionReportVisible ? "134px" : "80px",
            }}
            className={`${styles["excel-download-floating-btn"]} ${scrolled ? styles["show"] : ""}`}
          >
            <FaDownload />
          </button>
        </AntTooltip>
      )}

      {showReportDownloadModal && (
        <Modal
          open={showReportDownloadModal}
          onCancel={() => {
            setShowReportDownloadModal(false);
            setSelectedLocationForReport(null);
            setReportFilterFromDate(null);
            setReportFilterToDate(null);
          }}
          footer={null}
        >
          <div>
            <h6> Download Monthly Session Report </h6>
            <div className={styles["download-report-locSelection"]}>
              <Select
                showSearch
                // defaultValue="Select Location"
                placeholder="Select Location"
                // className={styles['ant-select-selection-overflow']}
                style={{ minWidth: "100%" }}
                value={selectedLocationForReport || undefined}
                onChange={(value) => {
                  setSelectedLocationForReport(value);
                  // console.log("set location for report ", value)
                  // setLocationForFilter(value);
                }}
                //onSearch={onSearch}
                allowClear
                options={locationsData.map((element) => ({
                  value: element._id,
                  label: element.locationName,
                }))}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onClear={() => console.log("clear selection")}
                size="middle"
                // maxTagCount={scrolled && showFilters && 1}
              />
            </div>

            <div className={styles["download-report-date"]}>
              <DatePicker
                picker="month"
                disabledDate={disableFutureDates}
                style={{ width: 170 }}
                placeholder="Selection Month"
                onChange={(date) => setReportFilterFromDate(date)}
                value={reportFilterFromDate}
              />

              {/* <DatePicker disabledDate={disableFutureDates} style={{width:170}} placeholder='End Date' onChange={(date) => setReportFilterToDate(date)}  value={reportFilterToDate}/> */}

              <Button
                loading={loading.sessionReport}
                type="primary"
                onClick={() => {
                  callSessionReportLambdaFunction();
                }}
              >
                {loading.sessionReport
                  ? "Downloading..."
                  : "Download Report"}{" "}
              </Button>
            </div>
          </div>
        </Modal>
      )}

      <div
        className={`${styles["row-containers"]} ${
          scrolled &&
          showFilters &&
          type !== "Admin" &&
          type !== "Breathe-Admin" &&
          styles["customer-filter-button-block-view"]
        } ${
          type === "Admin" || type === "Breathe-Admin"
            ? styles["admin-view-first-row"]
            : styles["customer-view-first-row"]
        } ${styles["filter"]} ${
          scrolled && showFilters ? styles["fixed-filter"] : ""
        } mt-4`}
      >
        <div
          className={`${
            scrolled &&
            showFilters &&
            type !== "Admin" &&
            type !== "Breathe-Admin"
              ? styles["filter-left-customer-view"]
              : styles["filter-left"]
          }`}
        >
          {(type === "Admin" || type === "Breathe-Admin") && (
            <div className={`${styles["dashboard-selector"]}`}>
              <div>
                {windowDashboardSelector === true &&
                !(scrolled && showFilters) ? (
                  <><ConfigProvider
                    theme={{
                      token: {
                        // Seed Token
                        colorPrimary: "#18365E",
                        // fontSize:'0.70rem'
                        // colorPrimary: '#309f40'
                        // borderRadius: 2,

                        // Alias Token
                        // colorBgContainer: '#f6ffed',
                      },
                    }}
                  >
                    <Radio.Group
                      defaultValue="Location Level Dashboard"
                      size="middle"
                      buttonStyle="solid"
                      onChange={(event) => {
                        setCurrentDashboard(event.target.value);
                      }}
                    >
                      <Radio.Button value="Location Level Dashboard">
                        Location Level Dashboard
                      </Radio.Button>
                      <Radio.Button value="Global Level Dashboard">
                        Global Level Dashboard
                      </Radio.Button>
                    </Radio.Group>


                    {(type === "Admin" || type === "Breathe-Admin") && (
              <div>
                <AntTooltip title="Download Excel containing all graph data">
                  <Button
                    type="primary"
                    icon={<FaDownload />}
                    onClick={()=>{downloadAllGraphsExcel()}}
                    loading={isExcelDownloading}
                    className={styles["download-excel-btn"]}
                    style={{
                      backgroundColor: "#18365E",
                      borderColor: "#18365E",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      width: "100%",
                      marginTop: "0.5rem",
                    }}
                  >
                    Download Excel
                  </Button>
                </AntTooltip>
              </div>
            )}
                  </ConfigProvider>
                      
                      
                  </>
                  
                ) : (
                  <>
                    <div style={{ marginBottom: "0.75rem" }}>
                      <ConfigProvider wave={{ disabled: true }}>
                        <Button
                          className={
                            currentDashboard === "Location Level Dashboard" &&
                            styles["selected-button-color"]
                          }
                          onClick={() => {
                            setCurrentDashboard("Location Level Dashboard");
                          }}
                          style={{ width: "100%" }}
                        >
                          Location Level Dashboard
                        </Button>
                      </ConfigProvider>
                    </div>
                    <div>
                      <ConfigProvider wave={{ disabled: true }}>
                        <Button
                          className={
                            currentDashboard === "Global Level Dashboard" &&
                            styles["selected-button-color"]
                          }
                          onClick={() => {
                            setCurrentDashboard("Global Level Dashboard");
                          }}
                          style={{ width: "100%" }}
                        >
                          Global Level Dashboard
                        </Button>
                      </ConfigProvider>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          <div
            style={{
              minWidth: "100%",
              display: "flex",
              gap: "0.5rem",
              alignItems: "flex-start",
            }}
          >
            {/* {currentDashboard === "Location Metrics Dashboard" && */}
            <Select
              style={{ width: "30%", flexShrink: 0 }}
              placeholder="Select State"
              value={selectedState || undefined}
              onChange={(value) => {
                setSelectedState(value);
                setLocationForFilter([], value);
              }}
              options={states.map((state) => ({
                value: state,
                label: state,
              }))}
              allowClear
              onClear={() => {
                setSelectedState(null);
                setLocationForFilter([]);
              }}
            />
            <Select
              showSearch
              // defaultValue="Select Location"
              placeholder={
                currentDashboard === "Global Level Dashboard"
                  ? "Location Disabled"
                  : "Select Location"
              }
              // className={styles['ant-select-selection-overflow']}
              style={{ flex: 1, minWidth: 0 }}
              value={location ? location : []}
              onChange={(value) => {
                setSelectedState(null);
                setLocationForFilter(value);
              }}
              //onSearch={onSearch}
              disabled={currentDashboard === "Global Level Dashboard"}
              allowClear
              options={locationsData.map((element) => ({
                value: element._id,
                label: element.locationName,
              }))}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              onClear={() => setLocationForFilter([])}
              mode="multiple"
              size="middle"
              maxTagCount={scrolled && showFilters && 1}
            />

            {/* } */}
          </div>
        </div>
        <div
          className={`${styles["date-select"]} ${
            scrolled && showFilters
              ? styles["filter-right-scrolled"]
              : styles["filter-right"]
          }`}
        >
          <div
            className={`${
              scrolled && showFilters
                ? styles["filter-dates-filter-button"]
                : styles["filter-dates"]
            }`}
          >
            <div>
              <DatePicker
                size="middle"
                value={
                  filterFromDate
                    ? dayjs(filterFromDate)
                    : dayjs().subtract(6, "month").startOf("day")
                }
                placeholder="Date From"
                onChange={(date) =>
                  setFilterFromDate(
                    date ? new Date(new Date(date).setHours(0, 0, 0, 0)) : null,
                  )
                }
                inputReadOnly={true}
                disabledDate={(current) =>
                  current.isAfter(dayjs().endOf("day")) ||
                  (filterToDate &&
                    current.isAfter(dayjs(filterToDate).endOf("day")))
                }
              />
            </div>
            <div>
              <DatePicker
                size="middle"
                // style={{minWidth:'100%'}}
                value={
                  filterToDate ? dayjs(filterToDate) : dayjs().endOf("day")
                }
                inputReadOnly={true}
                placeholder="Date To"
                onChange={(date) =>
                  setFilterToDate(
                    date
                      ? new Date(new Date(date).setHours(23, 59, 59, 999))
                      : null,
                  )
                }
                disabledDate={(current) =>
                  current.isAfter(dayjs().endOf("day")) ||
                  (filterFromDate
                    ? current.isBefore(dayjs(filterFromDate))
                    : current.isBefore(
                        dayjs().subtract(6, "month").startOf("day"),
                      ))
                }
              />
            </div>
            {currentDashboard === "Location Level Dashboard" ? (
              <div>
                <Select
                  size="middle"
                  value={selectedTimeZone}
                  style={{ minWidth: "100%" }}
                  onChange={(value) => setSelectedTimeZone(value)}
                >
                  <Select.Option value="UTC">UTC</Select.Option>
                  <Select.Option value="LocalTimeZone">
                    LocalTimeZone
                  </Select.Option>
                </Select>
              </div>
            ) : (
              <></>
            )}

            {/* {(type === "Admin" || type === "Breathe-Admin") && (
              <div>
                <AntTooltip title="Download Excel containing all graph data">
                  <Button
                    type="primary"
                    icon={<FaDownload />}
                    onClick={downloadAllGraphsExcel}
                    loading={isExcelDownloading}
                    className={styles["download-excel-btn"]}
                    style={{
                      backgroundColor: "#18365E",
                      borderColor: "#18365E",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      width: "100%",
                    }}
                  >
                    Download Excel
                  </Button>
                </AntTooltip>
              </div>
            )} */}

            {/* <div style={{minWidth:'100%'}}> */}
            {/* <Space direction="vertical" > */}
            {/* </Space> */}
            {/* </div> */}
            {/* </Space> */}
          </div>
          {(type === "Admin" || type === "Breathe-Admin") && (
            <div className={styles["admin-credit-view-block"]}>
              <div
                // style={{ minWidth: "100%" }}
                className={` ${
                  scrolled && showFilters
                    ? styles["admin-credit-view-hide"]
                    : styles["admin-credit-view"]
                } `}
              >
                Admin Credits :
                <span className={` ${styles["admin-credit-view-value"]} `}>
                  {" "}
                  ${" "}
                  {adminCredits.totalAdminCredits
                    ? adminCredits.totalAdminCredits.toFixed(2)
                    : 0}{" "}
                </span>
              </div>
              <div
                // style={{ minWidth: "100%" }}
                className={` ${
                  scrolled && showFilters
                    ? styles["admin-credit-view-hide"]
                    : styles["admin-credit-view"]
                } `}
              >
                Booking Refunds :
                <span className={` ${styles["admin-credit-view-value"]} `}>
                  {" "}
                  $ {parseFloat(refundData).toFixed(2)}{" "}
                </span>
              </div>
            </div>
          )}
        </div>

        {/* <div className={`${styles["date-select"]} ${styles["filter-right"]}`}>
          {isSessionReportVisible && (
            <Button
              type="primary"
              
            >
              Session Report
            </Button>
          )}
        </div> */}
      </div>

      {/* ______________________________________________ */}

      {currentDashboard === "Location Level Dashboard" ? (
        <>
          <div
            className={`${styles["row-containers"]} ${styles["second-row"]}`}
          >
            <div
              className={`${styles["data-view"]} ${
                styles["second-row-data-view"]
              } ${
                type === "Admin" || type === "Breathe-Admin"
                  ? ""
                  : styles["customer-second-row-data-view"]
              }`}
            >
              {type === "Admin" || type === "Breathe-Admin" ? (
                <div className={`${styles["first-block"]}`}>
                  <div className={styles["data-view-revenue"]}>
                    {loading.DashboardEnergyConsumptionData ? (
                      <div>
                        <NumericLoader />
                      </div>
                    ) : (
                      <div>
                        {totalEnergyConsumptionData
                          ? parseFloat(totalEnergyConsumptionData).toFixed(4)
                          : 0}{" "}
                        kWh
                      </div>
                    )}
                    <div className={styles["data-view-headings"]}>
                      Energy Delivered
                    </div>
                  </div>
                  <div className={styles["data-view-revenue"]}>
                    {loading.DashboardRevenueData ? (
                      <div>
                        <NumericLoader />
                      </div>
                    ) : (
                      <div>
                        ${" "}
                        {totalBreatheRevenue
                          ? parseFloat(
                              totalBreatheRevenue + totalCustomerRevenue,
                            ).toFixed(2)
                          : 0}
                      </div>
                    )}
                    <div className={styles["data-view-headings"]}>
                      Generated Revenue
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <AiFillThunderbolt />
                  <div className={styles["data-view-revenue"]}>
                    {loading.DashboardEnergyConsumptionData ? (
                      <div>
                        <NumericLoader />
                      </div>
                    ) : (
                      <div>
                        {totalEnergyConsumptionData
                          ? parseFloat(totalEnergyConsumptionData).toFixed(4)
                          : 0}{" "}
                        kWh
                      </div>
                    )}
                    <div className={styles["data-view-headings"]}>
                      Energy Delivered
                    </div>
                  </div>
                </>
              )}
            </div>

            {type === "Admin" || type === "Breathe-Admin" ? (
              <>
                {/* <div className={`${styles['second-row-revenue-block']}`}>

              <div className={styles['data-view-revenue']} >
                <div>$ {totalBreatheRevenue ? parseFloat(totalBreatheRevenue).toFixed(2) : 0}</div>
                <div className={styles['data-view-headings']}>BreatheEV Revenue</div>
              </div>

              <div className={styles['data-view-revenue']} >
                <div>$ {totalCustomerRevenue ? parseFloat(totalCustomerRevenue).toFixed(2) : 0}</div>
                <div className={styles['data-view-headings']}>Customer Revenue</div>
              </div>
            </div>


            <div className={`${styles['second-row-revenue-block']}`}>
              <div className={styles['data-view-revenue']} >
                <div className={styles['breathe-revenue']}>
                  <span><FaDotCircle className={`${styles['pi-badge']} ${styles['shared']}`} height={'12px'}/> 
                  $ {(breatheRevenueData[0]-totalCustomerRevenue).toFixed(2)}  
                  </span>   
                  <span><FaDotCircle className={`${styles['pi-badge']} ${styles['misc']}`} /> 
                  $ {breatheRevenueData[1].toFixed(2)} </span>
                  <span><FaDotCircle className={`${styles['pi-badge']} ${styles['perport']}`} /> 
                  $ {breatheRevenueData[2].toFixed(2)}</span>
                </div>
        
                  <div className={styles['breathe-rev-split']}>
                   <span className={styles['data-view-headings']}>BEV Rev-Share</span>
                   <span className={styles['data-view-headings']}>BEV Misc</span>
                   <span className={styles['data-view-headings']}>BEV Per-Port</span>
                  </div>
               

              </div>

            </div>
           */}

                <div className={`${styles["second-row-revenue-block"]}`}>
                  <AntTooltip
                    title={
                      loading.DashboardRevenueData
                        ? ""
                        : `Customer Revenue = $${(parseFloat(totalCustomerRevenue || 0) + parseFloat(totalTransactionFee || 0)).toFixed(2)} - $${parseFloat(totalTransactionFee || 0).toFixed(2)} = $${parseFloat(totalCustomerRevenue || 0).toFixed(2)}`
                    }
                  >
                    <div className={styles["data-view-revenue"]}>
                      {loading.DashboardRevenueData ? (
                        <div>
                          <NumericLoader />
                        </div>
                      ) : (
                        <div>
                          ${" "}
                          {totalCustomerRevenue
                            ? parseFloat(totalCustomerRevenue).toFixed(2)
                            : 0}
                        </div>
                      )}
                      <div className={styles["data-view-headings"]}>
                        Customer Revenue
                      </div>
                    </div>
                  </AntTooltip>
                  <div className={styles["data-view-revenue"]}>
                    {loading.DashboardRevenueData ? (
                      <div>
                        <NumericLoader />
                      </div>
                    ) : (
                      <div>
                        ${" "}
                        {totalBreatheRevenue
                          ? parseFloat(totalBreatheRevenue).toFixed(2)
                          : 0}
                      </div>
                    )}
                    <div className={styles["data-view-headings"]}>
                      BreatheEV Revenue
                    </div>
                  </div>

                  <div className={styles["data-view-revenue"]}>
                    <div className={styles["breathe-revenue"]}>
                      {loading.DashboardRevenueData ? (
                        <div>
                          <NumericLoader />
                        </div>
                      ) : (
                        <span>
                          <FaDotCircle
                            className={`${styles["pi-badge"]} ${styles["shared"]}`}
                            height={"12px"}
                          />
                          ${" "}
                          {(
                            breatheRevenueData[0] - totalCustomerRevenue
                          ).toFixed(2)}
                        </span>
                      )}
                      {loading.DashboardRevenueData ? (
                        <div>
                          <NumericLoader />
                        </div>
                      ) : (
                        <span>
                          <FaDotCircle
                            className={`${styles["pi-badge"]} ${styles["perport"]}`}
                          />
                          $ {breatheRevenueData[2].toFixed(2)}
                        </span>
                      )}
                    </div>
                    <div className={styles["breathe-rev-split"]}>
                      <span className={styles["data-view-headings"]}>
                        BEV Rev-Share
                      </span>
                      <span className={styles["data-view-headings"]}>
                        BEV Per-Port
                      </span>
                    </div>
                  </div>
                  <div className={styles["data-view-revenue"]}>
                    <div className={styles["breathe-revenue"]}>
                      {loading.DashboardRevenueData ? (
                        <div>
                          <NumericLoader />
                        </div>
                      ) : (
                        <span>
                          <FaDotCircle
                            className={`${styles["pi-badge"]} ${styles["misc"]}`}
                          />
                          $ {breatheRevenueData[1].toFixed(2)}{" "}
                        </span>
                      )}
                      {loading.DashboardRevenueData ? (
                        <div>
                          <NumericLoader />
                        </div>
                      ) : (
                        <span>
                          <FaDotCircle
                            className={`${styles["pi-badge"]} ${styles["tax"]}`}
                          />
                          $ {breatheRevenueData[3]?.toFixed(2) || 0}
                        </span>
                      )}
                    </div>
                    <div className={styles["breathe-rev-split"]}>
                      <span className={styles["data-view-headings"]}>
                        BEV Misc
                      </span>
                      <span className={styles["data-view-headings"]}>
                        Tax Collected
                      </span>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div
                className={`${styles["data-view"]} ${
                  styles["second-row-data-view"]
                } ${styles["customer-second-row-special-view"]} ${
                  type === "Admin" || type === "Breathe-Admin"
                    ? ""
                    : styles["customer-second-row-data-view"]
                }`}
              >
                <MdAttachMoney />
                <div className={styles["data-view-revenue"]}>
                  {loading.DashboardRevenueData ? (
                    <div>
                      <NumericLoader />
                    </div>
                  ) : (
                    <div>
                      ${" "}
                      {totalCustomerRevenue
                        ? parseFloat(totalCustomerRevenue).toFixed(2)
                        : 0}
                    </div>
                  )}
                  <div className={styles["data-view-headings"]}>Revenue</div>
                </div>
              </div>
            )}
          </div>
          <div className={`${styles["row-containers"]} ${styles["third-row"]}`}>
            <div className={styles["graph-view"]}>
              {loading.DashboardEnergyConsumptionData ? (
                <BarChartLoader />
              ) : (
                <div>
                  <ResponsiveContainer width="100%" height={250}>
                    <div className={styles["graph-view-subheading"]}>
                      Energy Consumption
                      <TooltipView
                        text={
                          <span>
                            This graph shows the monthly energy consumption for
                            a location, It shows past 6 months data by default
                            <div>
                              Start Date:{" "}
                              {formatDate(
                                filterFromDate
                                  ? filterFromDate
                                  : new Date(
                                      new Date().setMonth(
                                        new Date().getMonth() - 6,
                                      ),
                                    ),
                              )}{" "}
                            </div>
                            <div>
                              End Date:{" "}
                              {formatDate(
                                filterToDate ? filterToDate : new Date(),
                              )}
                            </div>
                          </span>
                        }
                      />
                      {(type === "Admin" || type === "Breathe-Admin") && (
                        <AntTooltip
                          title="Download All Graphs Data (Excel)"
                          placement="right"
                        >
                          <button
                            onClick={()=>{downloadAllGraphsExcel('Energy Consumption')}}
                            className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                          >
                            <FaDownload />
                          </button>
                        </AntTooltip>
                      )}
                    </div>

                    <BarChart
                      data={monthlyEnergyConsumptionData}
                      margin={{ top: 10, right: 10, left: 20, bottom: 10 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        dataKey="_id"
                        tickFormatter={(value) => {
                          const temp = value.split("-");
                          return `${
                            months[parseInt(temp[0]) - 1]
                          }-${temp[1].slice(-2)}`;
                        }}
                        style={{ fontSize: "13px" }}
                      />
                      <YAxis
                        style={{ fontSize: "13px" }}
                        stroke="#1E3A5F"
                        domain={[
                          0,
                          () => {
                            const { divisor } = getEnergyUnit(
                              monthlyEnergyConsumptionData,
                            );
                            const rawMax =
                              monthlyEnergyConsumptionData &&
                              monthlyEnergyConsumptionData.length
                                ? monthlyEnergyConsumptionData.reduce(
                                    (acc, curr) => {
                                      const v =
                                        parseFloat(curr.EnergyConsumption) || 0;
                                      return v > acc ? v : acc;
                                    },
                                    0,
                                  )
                                : 50;
                            const scaledMax = rawMax / divisor;
                            const step =
                              divisor === 1000
                                ? scaledMax < 10
                                  ? 1
                                  : scaledMax < 100
                                    ? 1
                                    : scaledMax < 1000
                                      ? 5
                                      : 10
                                : scaledMax < 10
                                  ? 1
                                  : scaledMax < 100
                                    ? 1
                                    : scaledMax < 1000
                                      ? 10
                                      : 100;
                            return Math.ceil((scaledMax + step) / step) * step;
                          },
                        ]}
                        tickFormatter={(value) => {
                          const { unit } = getEnergyUnit(
                            monthlyEnergyConsumptionData,
                          );
                          return `${value}${unit}`;
                        }}
                      />
                      <Tooltip
                        formatter={(value) => {
                          const { divisor, unit } = getEnergyUnit(
                            monthlyEnergyConsumptionData,
                          );
                          return `${value} ${unit}`;
                          // [`${parseFloat((value / divisor).toFixed(2))} ${unit}`, 'Energy Consumption'];
                        }}
                      />

                      <Bar
                        // dataKey="EnergyConsumption"
                        dataKey={(entry) =>
                          parseFloat(
                            (
                              parseFloat(entry.EnergyConsumption || 0) /
                              getEnergyUnit(monthlyEnergyConsumptionData)
                                .divisor
                            ).toFixed(4),
                          )
                        }
                        name="Energy Consumption"
                        //  name={useResponsiveBarName('Energy Consumption', 'Energy Cons.')}
                        fill="#309f40"
                        activeBar={<Rectangle fill="green" stroke="white" />}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              )}
            </div>
            <div className={styles["graph-view"]}>
              {loading.DashboardRevenueData ? (
                <BarChartLoader />
              ) : (
                <div>
                  <div className={styles["graph-view-subheading"]}>
                    Revenue
                    <TooltipView
                      text={
                        <span>
                          This graph shows the monthly revenue generated for a
                          location. It shows past 6 months data by default
                          <div>
                            Start Date:{" "}
                            {formatDate(
                              filterFromDate
                                ? filterFromDate
                                : new Date(
                                    new Date().setMonth(
                                      new Date().getMonth() - 6,
                                    ),
                                  ),
                            )}{" "}
                          </div>
                          <div>
                            End Date:{" "}
                            {formatDate(
                              filterToDate ? filterToDate : new Date(),
                            )}
                          </div>
                        </span>
                      }
                    />{" "}
                    {(type === "Admin" || type === "Breathe-Admin") && (
                      <AntTooltip
                        title="Download All Graphs Data (Excel)"
                        placement="right"
                      >
                        <button
                          onClick={()=>{showPerChargerData ? downloadAllGraphsExcel('Revenue Per Charger') : downloadAllGraphsExcel('Monthly Revenue')}}
                          className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                        >
                          <FaDownload />
                        </button>
                      </AntTooltip>
                    )}
                    <div className={styles["revenue-per-charger"]}>
                      <span className={styles["revenue-per-charger-span"]}>
                        {type === "Admin" || type === "Breathe-Admin" ? (
                          <>
                            <Checkbox
                              size="small"
                              checked={showPerChargerData}
                              onChange={() =>
                                setShowPerChargerData(!showPerChargerData)
                              }
                              className={`${styles["custom-checkbox"]} `}
                              // style={{"color":"white"}}
                            >
                              REVENUE / CHARGER
                            </Checkbox>
                            <Checkbox
                              size="small"
                              checked={showTotalRevenueData}
                              onChange={() =>
                                setShowTotalRevenueData(!showTotalRevenueData)
                              }
                              className={`${styles["custom-checkbox"]} `}
                              // style={{"color":"white"}}
                            >
                              Total Revenue
                            </Checkbox>
                          </>
                        ) : (
                          <></>
                        )}
                      </span>

                      {/* <Switch
                        size="small"
                        checked={showPerChargerData}
                        onChange={() => setShowPerChargerData(!showPerChargerData)}
                        style={{ backgroundColor: showPerChargerData ? '#18365e' : undefined }}
                      />  */}
                    </div>
                  </div>
                  {/* {console.log("monthlyRevenueData", monthlyRevenueData)} */}
                  {type === "Admin" || type === "Breathe-Admin" ? (
                    <ResponsiveContainer width="100%" height={250}>
                      <BarChart
                        data={
                          showPerChargerData
                            ? monthlyRevenueDataPerCharger
                            : monthlyRevenueData
                        }
                        margin={{ top: 5, right: 5, left: 5, bottom: 5 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          dataKey="_id"
                          tickFormatter={(value) => {
                            const temp = value.split("-");
                            return `${
                              months[parseInt(temp[0]) - 1]
                            }-${temp[1].slice(-2)}`;
                          }}
                          style={{ fontSize: "13px" }}
                        />
                        <YAxis
                          style={{ fontSize: "13px" }}
                          orientation="left"
                          stroke="#18365E"
                          domain={
                            showPerChargerData
                              ? [
                                  0,
                                  () => {
                                    const maxRevenue =
                                      monthlyRevenueDataPerCharger.reduce(
                                        (acc, curr) => {
                                          const total =
                                            parseFloat(
                                              curr.breathePerPortRevenue || 0,
                                            ) +
                                            parseFloat(
                                              curr.breatheRevShareRevenue || 0,
                                            ) +
                                            parseFloat(
                                              curr.breatheMiscRevenue || 0,
                                            ) +
                                            parseFloat(
                                              (showTotalRevenueData
                                                ? curr.totalCustomerRevenue
                                                : 0) || 0,
                                            );
                                          return total > acc ? total : acc;
                                        },
                                        0,
                                      );

                                    // Round up to the nearest 100 and add an extra 100 buffer
                                    return Math.ceil(maxRevenue / 100) * 100;
                                  },
                                ]
                              : [
                                  0,
                                  () => {
                                    const maxRevenue =
                                      monthlyRevenueData.reduce((acc, curr) => {
                                        const total =
                                          parseFloat(
                                            curr.breathePerPortRevenue || 0,
                                          ) +
                                          parseFloat(
                                            curr.breatheRevShareRevenue || 0,
                                          ) +
                                          parseFloat(
                                            curr.breatheMiscRevenue || 0,
                                          ) +
                                          parseFloat(
                                            (showTotalRevenueData
                                              ? curr.totalCustomerRevenue
                                              : 0) || 0,
                                          ) +
                                          parseFloat(
                                            curr.breatheMUFRevenue || 0,
                                          );
                                        return total > acc ? total : acc;
                                      }, 0);

                                    // Round up to the nearest 100 and add an extra 100 buffer
                                    return (
                                      Math.ceil(maxRevenue / 100) * 100 + 100
                                    );
                                  },
                                ]
                          }
                          // domain={[
                          //   0,
                          //   parseInt(
                          //     Math.max(
                          //       monthlyRevenueData
                          //         ? monthlyRevenueData.reduce((acc, curr) => {
                          //             return (acc =
                          //               parseFloat(curr.breathePerPortRevenue) +
                          //                 parseFloat(
                          //                   curr.breatheRevShareRevenue
                          //                 ) +
                          //                 parseFloat(curr.breatheMiscRevenue) >
                          //               acc
                          //                 ? parseFloat(
                          //                     curr.breathePerPortRevenue
                          //                   ) +
                          //                   parseFloat(
                          //                     curr.breatheRevShareRevenue
                          //                   ) +
                          //                   parseFloat(curr.breatheMiscRevenue)
                          //                 : acc);
                          //           }, 0)
                          //         : 50
                          //     ) / 500
                          //   ) *
                          //     500 +
                          //     500,
                          // ]}
                          tickFormatter={(value) => `$${value}`}
                        />
                        {/* <YAxis yAxisId="four" orientation="right" stroke="#387908" /> */}
                        <Tooltip />
                        <Legend
                          style={{ fontSize: "12px" }}
                          iconSize={7}
                          iconType="line"
                          formatter={renderFomratter}
                        />
                        {showTotalRevenueData && (
                          <Bar
                            stackId="four"
                            dataKey={"totalCustomerRevenue"}
                            fill="#6fabf0ff"
                            name="Customer Revenue"
                          />
                        )}
                        <Bar
                          stackId="four"
                          name={"BEV MUF"}
                          dataKey="breatheMUFRevenue"
                          fill="#a4a6a7"
                        />
                        <Bar
                          stackId="four"
                          name={"BEV Per-Port"}
                          dataKey="breathePerPortRevenue"
                          fill="#ff7300"
                        />
                        <Bar
                          stackId="four"
                          name={"BEV Rev-Share"}
                          dataKey="breatheRevShareRevenue"
                          fill="#309f40"
                        />
                        <Bar
                          stackId="four"
                          name={"BEV Misc"}
                          dataKey="breatheMiscRevenue"
                          fill="#FFBB28"
                        />
                        <Bar
                          stackId="four"
                          name={"Tax Cost"}
                          dataKey="taxCost"
                          fill="#18365E"
                        />
                        <Bar
                          stackId="four"
                          name={"Total"}
                          dataKey={(entry) => {
                            const baseRev =
                              parseFloat(entry.breatheMUFRevenue || 0) +
                              parseFloat(entry.breathePerPortRevenue || 0) +
                              parseFloat(entry.breatheRevShareRevenue || 0) +
                              parseFloat(entry.breatheMiscRevenue || 0) +
                              parseFloat(entry.taxCost || 0);

                            const conditionalRev = showTotalRevenueData
                              ? parseFloat(entry.totalCustomerRevenue || 0)
                              : 0;

                            return (baseRev + conditionalRev).toFixed(2);
                          }}
                          fill="#000"
                          legendType="rect"
                          hide={false}
                          style={{ opacity: 0, pointerEvents: "none" }}
                        />
                        <Bar
                          stackId="four"
                          name={"Transaction Fee"}
                          dataKey="transactionFee"
                          fill="#000"
                          legendType="none"
                          hide={false}
                          style={{ opacity: 0, pointerEvents: "none" }}
                        />

                        {/* <Bar yAxisId="three" type="monotone" name={'Total Breathe Revenue'} dataKey="breatheTotalRevenue" stroke="#4ae94a" /> */}
                      </BarChart>
                      {/* <div className={`${styles['legend-main-div']}`}>
                  <div>
                    <span><FaDotCircle className={`${styles['pi-badge']} ${styles['shared']}`} /> BEV RevShare Revenue</span>
                    <span><FaDotCircle className={`${styles['pi-badge']} ${styles['shared']}`} /> BEV Perport Revenue</span>
                    </div>
                  <div>
                  <span><FaDotCircle className={`${styles['pi-badge']} ${styles['shared']}`} /> BEV Mics Revenue</span>
                  <span><FaDotCircle className={`${styles['pi-badge']} ${styles['shared']}`} /> BEV Total Revenue</span>
                  </div>
                </div> */}
                    </ResponsiveContainer>
                  ) : (
                    <ResponsiveContainer width="100%" height={250}>
                      <BarChart
                        data={
                          showPerChargerData
                            ? monthlyRevenueDataPerCharger
                            : monthlyRevenueData
                        }
                        margin={{ top: 10, right: 10, left: 15, bottom: 10 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          style={{ fontSize: "13px" }}
                          dataKey="_id"
                          tickFormatter={(value) => {
                            const temp = value.split("-");
                            return `${
                              months[parseInt(temp[0]) - 1]
                            }-${temp[1].slice(-2)}`;
                          }}
                        />

                        <YAxis
                          style={{ fontSize: "13px" }}
                          stroke="#1E3A5F"
                          tickFormatter={(value) => `$${value}`}
                        />
                        <Tooltip formatter={(value) => `$${value}`} />
                        {/* <Bar
                          stackId="four"
                          name={"BEV MUF"}
                          dataKey="breatheMUFRevenue"
                          fill="#18365e"
                        /> */}
                        <Bar
                          stackId="four"
                          dataKey={"totalCustomerRevenue"}
                          fill="#309f40"
                          name="Total Revenue"
                          activeBar={<Rectangle fill="green" stroke="white" />}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  )}
                </div>
              )}
            </div>
            <div className={styles["graph-view"]}>
              {loading.DashboardUtilizationData ? (
                <BarChartLoader />
              ) : (
                <div>
                  <div className={styles["graph-view-subheading"]}>
                    Utilization
                    <TooltipView
                      text={
                        <span>
                          This graph shows the monthly energy utilization for a
                          location. It shows past 6 months data by default
                          <div>
                            Start Date:{" "}
                            {formatDate(
                              filterFromDate
                                ? filterFromDate
                                : new Date(
                                    new Date().setMonth(
                                      new Date().getMonth() - 6,
                                    ),
                                  ),
                            )}{" "}
                          </div>
                          <div>
                            End Date:{" "}
                            {formatDate(
                              filterToDate ? filterToDate : new Date(),
                            )}
                          </div>
                        </span>
                      }
                    />{" "}
                    {(type === "Admin" || type === "Breathe-Admin") && (
                      <AntTooltip
                        title="Download All Graphs Data (Excel)"
                        placement="right"
                      >
                        <button
                          onClick={()=>{downloadAllGraphsExcel('Monthly Utilization')}}
                          className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                        >
                          <FaDownload />
                        </button>
                      </AntTooltip>
                    )}
                  </div>
                  <ResponsiveContainer width="100%" height={250}>
                    <BarChart
                      data={monthlyUtilization}
                      margin={{ top: 10, right: 10, left: 15, bottom: 10 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        style={{ fontSize: "13px" }}
                        dataKey="_id"
                        tickFormatter={(value) => {
                          const temp = value.split("-");
                          return `${
                            months[parseInt(temp[0]) - 1]
                          }-${temp[1].slice(-2)}`;
                        }}
                      />
                      <YAxis
                        style={{ fontSize: "13px" }}
                        stroke="#1E3A5F"
                        // domain={[0, ((parseInt(Math.max(monthlyUtilization?monthlyUtilization.reduce((acc,curr)=>{return acc = parseFloat(curr.MonthUtilization)>acc?parseFloat(curr.MonthUtilization):acc},0):1)/10)*10)+ 10)]}
                        domain={[
                          0,
                          parseInt(
                            Math.max(
                              monthlyUtilization
                                ? monthlyUtilization.reduce((acc, curr) => {
                                    return (acc =
                                      parseFloat(curr.MonthUtilization) > acc
                                        ? parseFloat(curr.MonthUtilization)
                                        : acc);
                                  }, 0)
                                : 1,
                            ) / 1.5,
                          ) *
                            1.5 +
                            1.5,
                        ]}
                        // domain={[0, Math.ceil(Math.max(...monthlyUtilization ? monthlyUtilization.map(item => parseFloat(item.MonthUtilization)) : [1]))]}
                        tickFormatter={(value) => `${value}%`}
                      />
                      <Tooltip
                        formatter={(value) =>
                          `${parseFloat(value).toFixed(2)}%`
                        }
                      />

                      <Bar
                        dataKey="MonthUtilization"
                        name="Utilization Percentage"
                        //  name={useResponsiveBarName('Utilization Percentage', 'Utilization')}
                        fill="#309f40"
                        activeBar={<Rectangle fill="green" stroke="white" />}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              )}
            </div>
          </div>
          <div
            className={`${styles["row-containers"]} ${styles["fourth-row"]}`}
          >
            <div className={`${styles["fourth-row-data-view"]} `}>
              <div
                className={`${styles["data-view"]} ${styles["fourth-row-block-one"]}`}
              >
                <HiUsers />
                <div>{totalUniqueUsers ? totalUniqueUsers : 0}</div>
                <div className={styles["data-view-headings"]}>
                  {isPublicLocationSelectedInFilter
                    ? "Total Users"
                    : "Total Unique Users"}
                </div>
              </div>

              <div
                className={`${styles["data-view"]} ${styles["fourth-row-block-two"]}`}
              >
                <FaClock />
                <div>
                  {averageBookingDuration
                    ? (averageBookingDuration / 60).toFixed(2)
                    : 0}{" "}
                  <span>Hrs</span>
                </div>
                <div className={styles["data-view-headings"]}>
                  Average Booking Duration
                </div>
              </div>
            </div>

            <div className={styles["graph-view"]}>
              {loading.DashboardDayUtilizationData ? (
                <BarChartLoader />
              ) : (
                <div>
                  <ResponsiveContainer width="100%" height={250}>
                    <div className={styles["graph-view-subheading-timezone"]}>
                      Uptime
                      <TooltipView
                        text={
                          <span>
                            This graph shows the Uptime for the chargers. It
                            shows past 6 months data by default
                            <div>
                              Start Date:{" "}
                              {formatDate(
                                filterFromDate
                                  ? filterFromDate
                                  : new Date(
                                      new Date().setMonth(
                                        new Date().getMonth() - 6,
                                      ),
                                    ),
                              )}{" "}
                            </div>
                            <div>
                              End Date:{" "}
                              {formatDate(
                                filterToDate ? filterToDate : new Date(),
                              )}
                            </div>
                          </span>
                        }
                      />{" "}
                      {(type === "Admin" || type === "Breathe-Admin") && (
                        <AntTooltip
                          title="Download All Graphs Data (Excel)"
                          placement="right"
                        >
                          <button
                            onClick={() => downloadAllGraphsExcel('Monthly Uptime')}
                            className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                          >
                            <FaDownload />
                          </button>
                        </AntTooltip>
                      )}
                    </div>
                    <div className={styles["timezone-text"]}>
                      {Intl.DateTimeFormat().resolvedOptions().timeZone}
                    </div>

                    <BarChart
                      data={monthlyUptime}
                      margin={{ top: 10, right: 10, left: 15, bottom: 10 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        style={{ fontSize: "13px" }}
                        dataKey="month"
                        tickFormatter={(value) => {
                          const temp = value.split("-");
                          return `${
                            months[parseInt(temp[1]) - 1]
                          }-${temp[0].slice(-2)}`;
                        }}
                      />
                      <YAxis
                        style={{ fontSize: "13px" }}
                        stroke="#1E3A5F"
                        domain={[0, 100]}
                        // tickFormatter={(value) => `${value}%`}
                        tickFormatter={(value) =>
                          `${Number(value).toFixed(2)}%`
                        }
                      />
                      <Tooltip formatter={(value) => `${value.toFixed(2)}%`} />

                      <Bar
                        dataKey="uptimePercentage"
                        name="Uptime Percentage"
                        //  name={useResponsiveBarName('Uptime Percentage', 'Uptime')}
                        fill="#309f40"
                        activeBar={<Rectangle fill="green" stroke="white" />}
                      />
                      {/* <Bar name={'Normalised Session Utilisation Ratio'}  fill="#82ca9d" />  */}
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              )}
            </div>

            <div className={styles["graph-view"]}>
              {loading.DashboardUtilizationData ? (
                <BarChartLoader />
              ) : (
                <div>
                  <div className={styles["graph-view-subheading-timezone"]}>
                    Time of day utilization
                    <TooltipView
                      text={
                        <span>
                          {" "}
                          This graph shows the normalised session precentage for
                          24 hrs
                          <div>
                            Start Date:{" "}
                            {formatDate(
                              filterFromDate
                                ? filterFromDate
                                : new Date(
                                    new Date().setMonth(
                                      new Date().getMonth() - 6,
                                    ),
                                  ),
                            )}{" "}
                          </div>
                          <div>
                            End Date:{" "}
                            {formatDate(
                              filterToDate ? filterToDate : new Date(),
                            )}
                          </div>
                        </span>
                      }
                    />
                    {(type === "Admin" || type === "Breathe-Admin") && (
                      <AntTooltip
                        title="Download All Graphs Data (Excel)"
                        placement="right"
                      >
                        <button
                          onClick={() => downloadAllGraphsExcel('Time of Day Utilization')}
                          className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                        >
                          <FaDownload />
                        </button>
                      </AntTooltip>
                    )}
                  </div>
                  <div className={styles["timezone-text"]}>
                    {Intl.DateTimeFormat().resolvedOptions().timeZone}
                  </div>

                  <ResponsiveContainer width="100%" height={250}>
                    <BarChart
                      data={averageDayUtilization}
                      margin={{ top: 10, right: 10, left: 15, bottom: 10 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        style={{ fontSize: "13px" }}
                        dataKey="startTime"
                        tickFormatter={(value) => {
                          const temp = value.split(":");
                          return `${temp[0]}`;
                        }}
                      />
                      <YAxis
                        style={{ fontSize: "13px" }}
                        stroke="#1E3A5F"
                        domain={[
                          0,
                          parseInt(
                            Math.max(
                              averageDayUtilization
                                ? averageDayUtilization.reduce((acc, curr) => {
                                    return (acc =
                                      parseFloat(curr.timeUtilisation) > acc
                                        ? parseFloat(curr.timeUtilisation)
                                        : acc);
                                  }, 0)
                                : 1,
                            ) / 1.5,
                          ) *
                            1.5 +
                            1.5,
                        ]}
                        // domain={[0, Math.ceil(Math.max(...averageDayUtilization ? averageDayUtilization.map(item => parseFloat(item.timeUtilisation)) : [1]))]}
                        tickFormatter={(value) => `${value}%`}
                      />
                      <Tooltip
                        labelFormatter={(hour) => `${hour}:00`}
                        formatter={(value) => `${value}%`}
                      />

                      <Bar
                        dataKey="timeUtilisation"
                        name="Hour Utilization Percentage"
                        // name={useResponsiveBarName('Hour Utilization Percentage', 'Hour Util.')}
                        fill="#309f40"
                        activeBar={<Rectangle fill="green" stroke="white" />}
                      />
                      {/* <Bar name={'Normalised Session Utilisation Ratio'}  fill="#82ca9d" />  */}
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              )}
            </div>
          </div>
          {(type === "Customer" ? isMUFGraphVisible : true) && (
            <div
              className={`${styles["row-containers"]} ${styles["fifth-row"]}`}
            >
              <div className={styles["graph-view"]}>
                {type === "Admin" || type === "Breathe-Admin" ? (
                  loading.DashboardDayOfWeekUtilizationData ? (
                    <BarChartLoader />
                  ) : (
                    <div>
                      <ResponsiveContainer width="100%" height={250}>
                        <div
                          className={styles["graph-view-subheading-timezone"]}
                        >
                          Day wise Utilization
                          <TooltipView
                            text={
                              <span>
                                This graph shows the Day wise utilization. It
                                shows past 6 months data by default
                                <div>
                                  Start Date:{" "}
                                  {formatDate(
                                    filterFromDate
                                      ? filterFromDate
                                      : new Date(
                                          new Date().setMonth(
                                            new Date().getMonth() - 6,
                                          ),
                                        ),
                                  )}{" "}
                                </div>
                                <div>
                                  End Date:{" "}
                                  {formatDate(
                                    filterToDate ? filterToDate : new Date(),
                                  )}
                                </div>
                              </span>
                            }
                          />
                          {(type === "Admin" || type === "Breathe-Admin") && (
                            <AntTooltip
                              title="Download All Graphs Data (Excel)"
                              placement="right"
                            >
                              <button
                                onClick={() => downloadAllGraphsExcel('Day Wise Utilization')}
                                className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                              >
                                <FaDownload />
                              </button>
                            </AntTooltip>
                          )}
                        </div>
                        <div className={styles["timezone-text"]}>
                          {Intl.DateTimeFormat().resolvedOptions().timeZone}
                        </div>

                        <BarChart
                          data={dayOfWeekUtilization}
                          margin={{ top: 10, right: 10, left: 15, bottom: 10 }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis
                            style={{ fontSize: "13px" }}
                            dataKey="day"
                            // tickFormatter={(value) => {
                            //   const temp = value.split("-");
                            //   return `${
                            //     months[parseInt(temp[1]) - 1]
                            //   }-${temp[0].slice(-2)}`;
                            // }}
                          />
                          <YAxis
                            style={{ fontSize: "13px" }}
                            stroke="#1E3A5F"
                            domain={[
                              0,
                              parseInt(
                                Math.max(
                                  dayOfWeekUtilization
                                    ? dayOfWeekUtilization.reduce(
                                        (acc, curr) => {
                                          return (acc =
                                            parseFloat(curr.utilization) > acc
                                              ? parseFloat(curr.utilization)
                                              : acc);
                                        },
                                        0,
                                      )
                                    : 1,
                                ) / 1.5,
                              ) *
                                1.5 +
                                1.5,
                            ]}
                            tickFormatter={(value) => `${value}%`}
                          />
                          <Tooltip
                            formatter={(value) => `${value.toFixed(2)}%`}
                          />

                          <Bar
                            dataKey="utilization"
                            name="Day Utilization Percentage"
                            //  name={useResponsiveBarName('Uptime Percentage', 'Uptime')}
                            fill="#309f40"
                            activeBar={
                              <Rectangle fill="green" stroke="white" />
                            }
                          />
                          {/* <Bar name={'Normalised Session Utilisation Ratio'}  fill="#82ca9d" />  */}
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  )
                ) : loading.DashboardRevenueData ? (
                  <BarChartLoader />
                ) : (
                  <div>
                    <ResponsiveContainer width="100%" height={250}>
                      <div className={styles["graph-view-subheading-timezone"]}>
                        MUF Amount
                        <TooltipView
                          text={
                            <span>
                              This graph shows the MUF Amount paid towards
                              BreatheEV on a monthly basis. It shows past 6
                              months data by default
                              <div>
                                Start Date:{" "}
                                {formatDate(
                                  filterFromDate
                                    ? filterFromDate
                                    : new Date(
                                        new Date().setMonth(
                                          new Date().getMonth() - 6,
                                        ),
                                      ),
                                )}{" "}
                              </div>
                              <div>
                                End Date:{" "}
                                {formatDate(
                                  filterToDate ? filterToDate : new Date(),
                                )}
                              </div>
                            </span>
                          }
                        />
                      </div>
                      <div className={styles["timezone-text"]}>
                        {Intl.DateTimeFormat().resolvedOptions().timeZone}
                      </div>

                      <BarChart
                        data={monthlyRevenueData}
                        margin={{ top: 10, right: 10, left: 15, bottom: 10 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          style={{ fontSize: "13px" }}
                          dataKey="_id"
                          tickFormatter={(value) => {
                            const temp = value.split("-");
                            return `${
                              months[parseInt(temp[0]) - 1]
                            }-${temp[1].slice(-2)}`;
                          }}
                        />
                        <YAxis
                          style={{ fontSize: "13px" }}
                          stroke="#1E3A5F"
                          domain={[
                            0,
                            parseInt(
                              Math.max(
                                monthlyRevenueData
                                  ? monthlyRevenueData.reduce((acc, curr) => {
                                      return (acc =
                                        parseFloat(curr.breatheMUFRevenue) > acc
                                          ? parseFloat(curr.breatheMUFRevenue)
                                          : acc);
                                    }, 0)
                                  : 1,
                              ) / 1.5,
                            ) *
                              1.5 +
                              1.5,
                          ]}
                          tickFormatter={(value) => `$${value}`}
                        />
                        <Tooltip
                          formatter={(value) => `$${value.toFixed(2)}`}
                        />

                        <Bar
                          dataKey="breatheMUFRevenue"
                          name="MUF Amount"
                          //  name={useResponsiveBarName('Uptime Percentage', 'Uptime')}
                          fill="#309f40"
                          activeBar={<Rectangle fill="green" stroke="white" />}
                        />
                        {/* <Bar name={'Normalised Session Utilisation Ratio'}  fill="#82ca9d" />  */}
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                )}
              </div>
              <div className={`${styles["fifth-row-data-view"]} `}>
                <div
                  className={`${styles["data-view"]} ${styles["fifth-row-block-one"]}`}
                >
                  <FaChargingStation />
                  <div>{chargerCount ? chargerCount : 0}</div>
                  <div className={styles["data-view-headings"]}>
                    Total Chargers
                  </div>
                </div>

                <div
                  className={`${styles["data-view"]} ${styles["fifth-row-block-two"]}`}
                >
                  <PiPlugsConnectedBold />
                  <div>{connectorCount ? connectorCount : 0} </div>
                  <div className={styles["data-view-headings"]}>
                    Total Connectors
                  </div>
                </div>
              </div>
            </div>
          )}
          {(type === "Admin" || type === "Breathe-Admin") && (
            <div
              className={`${styles["row-containers"]} ${styles["sixth-row"]} `}
            >
              <div
                className={`${styles["graph-view-sixth-row"]} ${styles["graph-view"]}`}
              >
                {loading.DashboardAverageChargingSpeed ? (
                  <BarChartLoader />
                ) : (
                  <div>
                    <ResponsiveContainer width="100%" height={250}>
                      <div className={styles["graph-view-subheading-timezone"]}>
                        Average Charging Speed
                        <TooltipView
                          text={
                            <span>
                              This graph shows the average charging speed of the
                              chargers. It shows past 6 months data by default
                              <div>
                                Start Date:{" "}
                                {formatDate(
                                  filterFromDate
                                    ? filterFromDate
                                    : new Date(
                                        new Date().setMonth(
                                          new Date().getMonth() - 6,
                                        ),
                                      ),
                                )}{" "}
                              </div>
                              <div>
                                End Date:{" "}
                                {formatDate(
                                  filterToDate ? filterToDate : new Date(),
                                )}
                              </div>
                            </span>
                          }
                        />
                        {(type === "Admin" || type === "Breathe-Admin") && <AntTooltip title="Download All Graphs Data (Excel)" placement="right">
                              <button
                                onClick={() => downloadAllGraphsExcel('Avg Charging Speed')}
                                className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                              >
                                <FaDownload />
                              </button>
                            </AntTooltip>}
                      </div>
                      <div className={styles["timezone-text"]}>
                        {Intl.DateTimeFormat().resolvedOptions().timeZone}
                      </div>

                      <BarChart
                        data={averageChargingSpeed}
                        margin={{ top: 10, right: 10, left: 15, bottom: 10 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          style={{ fontSize: "13px" }}
                          dataKey="_id"
                          tickFormatter={(value) => {
                            const temp = value.split("-");
                            return `${
                              months[parseInt(temp[0]) - 1]
                            }-${temp[1].slice(-2)}`;
                          }}
                        />
                        <YAxis
                          style={{ fontSize: "13px" }}
                          stroke="#1E3A5F"
                          domain={[
                            0,
                            parseInt(
                              Math.max(
                                averageChargingSpeed
                                  ? averageChargingSpeed.reduce((acc, curr) => {
                                      return (acc =
                                        parseFloat(curr.averageChargingSpeed) >
                                        acc
                                          ? parseFloat(
                                              curr.averageChargingSpeed,
                                            )
                                          : acc);
                                    }, 0)
                                  : 1,
                              ) / 1.5,
                            ) *
                              1.5 +
                              1.5,
                          ]}
                          tickFormatter={(value) => `${value} kW`}
                        />
                        <Tooltip
                          formatter={(value) => `${value.toFixed(2)} kW`}
                        />

                        <Bar
                          dataKey="averageChargingSpeed"
                          name="Average Charging Speed"
                          //  name={useResponsiveBarName('Uptime Percentage', 'Uptime')}
                          fill="#309f40"
                          activeBar={<Rectangle fill="green" stroke="white" />}
                        />
                        {/* <Bar name={'Normalised Session Utilisation Ratio'}  fill="#82ca9d" />  */}
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          <div
            className={`${styles["row-containers"]} ${styles["fourth-row"]}`}
          >
            <div className={`${styles["fourth-row-data-view"]} `}>
              <div
                className={`${styles["data-view"]} ${styles["fourth-row-block-one"]}`}
              >
                {/* <HiUsers /> */}
                <div>{totalRegisteredUsers ? totalRegisteredUsers : 0}</div>
                <div className={styles["data-view-headings"]}>
                  Total Registered Users
                </div>
              </div>

              <div
                className={`${styles["data-view"]} ${styles["fourth-row-block-two"]}`}
              >
                {/* <FaClock /> */}
                <div>
                  {usersRegisteredButNeverCharged
                    ? usersRegisteredButNeverCharged
                    : 0}{" "}
                </div>
                <div className={styles["data-view-headings"]}>
                  Total Active Users
                </div>
              </div>
            </div>

            <div
              // style={{width:'66%'}}
              className={`${styles["fourth-row-graph-view"]}`}
            >
              <div>
                <ResponsiveContainer width="100%" height={250}>
                  <div className={styles["graph-view-subheading"]}>
                    Admin Credits
                    <TooltipView
                      text={
                        <span>
                          This graph shows the amount in dollars credited to
                          users by the BreatheEV. It shows past 6 months data by
                          default
                          <div>
                            Start Date:{" "}
                            {formatDate(
                              filterFromDate
                                ? filterFromDate
                                : new Date(
                                    new Date().setMonth(
                                      new Date().getMonth() - 6,
                                    ),
                                  ),
                            )}{" "}
                          </div>
                          <div>
                            End Date:{" "}
                            {formatDate(
                              filterToDate ? filterToDate : new Date(),
                            )}
                          </div>
                        </span>
                      }
                    /> {(type === "Admin" || type === "Breathe-Admin") && <AntTooltip title="Download All Graphs Data (Excel)" placement="right">
                            <button
                              onClick={() => downloadAllGraphsExcel('Admin Credits')}
                              className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                            >
                              <FaDownload />
                            </button>
                          </AntTooltip>}
                  </div>

                  <BarChart
                    data={adminCredits.adminCredits}
                    margin={{ top: 10, right: 10, left: 15, bottom: 10 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis
                      style={{ fontSize: "13px" }}
                      dataKey="monthYear"
                      tickFormatter={(value) => {
                        const temp = value.split("-");
                        return `${
                          months[parseInt(temp[0]) - 1]
                        }-${temp[1].slice(-2)}`;
                      }}
                    />
                    {
                      // console.log('registered users max val ',((parseInt(Math.max(registeredUsers?registeredUsers.reduce((acc,curr)=>{return acc = curr.registeredUsers>acc?curr.registeredUsers:acc},0):50)/10)*10)+ 10))
                    }
                    {/* Math.ceil(parseInt(Math.max(...registeredUsers.registeredUsers ? registeredUsers.map((item) => parseInt(item.registeredUsers)) : [50]) / 10)*10 + 10 ) */}
                    <YAxis
                      style={{ fontSize: "13px" }}
                      stroke="#1E3A5F"
                      domain={[
                        0,
                        parseInt(
                          Math.max(
                            adminCredits
                              ? adminCredits.adminCredits.reduce(
                                  (acc, curr) => {
                                    return (acc =
                                      curr.adminCredits > acc
                                        ? curr.adminCredits
                                        : acc);
                                  },
                                  0,
                                )
                              : 50,
                          ) / 50,
                        ) *
                          50 +
                          50,
                      ]}
                      // domain={[0,((parseInt(Math.max(registeredUsers?registeredUsers.reduce((acc,curr)=>{return acc = curr.registeredUsers>acc?curr.registeredUsers:acc},0):50)/10)*10)+ 10) ]}
                      tickFormatter={(value) => `$ ${value}`}
                    />
                    <Tooltip
                      formatter={(value) => `$${value}`}
                      labelFormatter={(value) => {
                        const temp = value.split("-");
                        return `${temp[0].padStart(2, "0")}-${temp[1]}`;
                      }}
                    />

                    <Bar
                      dataKey="adminCredits"
                      name="Admin Credits"
                      //  name={useResponsiveBarName('Uptime Percentage', 'Uptime')}
                      fill="#309f40"
                      activeBar={<Rectangle fill="green" stroke="white" />}
                    />
                    {/* <Bar name={'Normalised Session Utilisation Ratio'}  fill="#82ca9d" />  */}
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>

          {/* next field start  */}

          <div
            className={`${styles["row-containers"]} ${styles["fourth-row"]}`}
          >
            <div
              // style={{width:'66%'}}
              className={`${styles["utilization-perUser-div"]}`}
            >
              <div>
                {loading.DashboardRevenueData ? (
                  <BarChartLoader />
                ) : (
                  <ResponsiveContainer width="100%" height={250}>
                    <div className={styles["graph-view-subheading"]}>
                      Revenue / User
                      <TooltipView
                        text={
                          <span>
                            This graph shows the amount ($) accrued per user by
                            BreatheEv. It shows past 6 months data by default
                            <div>
                              Start Date:{" "}
                              {formatDate(
                                filterFromDate
                                  ? filterFromDate
                                  : new Date(
                                      new Date().setMonth(
                                        new Date().getMonth() - 6,
                                      ),
                                    ),
                              )}{" "}
                            </div>
                            <div>
                              End Date:{" "}
                              {formatDate(
                                filterToDate ? filterToDate : new Date(),
                              )}
                            </div>
                          </span>
                        }
                      />
                      {(type === "Admin" || type === "Breathe-Admin") && <AntTooltip title="Download All Graphs Data (Excel)" placement="right">
                        <button
                          onClick={() => downloadAllGraphsExcel('Revenue Per User')}
                          className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                        >
                          <FaDownload />
                        </button>
                      </AntTooltip>}
                    </div>
                    {/* {console.log("monthlyUtilizationRevenueDataPerUserState in graph: ", monthlyUtilizationRevenueDataPerUserState)} */}
                    <BarChart
                      data={monthlyUtilizationRevenueDataPerUserState}
                      margin={{ top: 10, right: 10, left: 15, bottom: 10 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />

                      <XAxis
                        style={{ fontSize: "13px" }}
                        dataKey="_id"
                        tickFormatter={(value) => {
                          const temp = value.split("-");
                          return `${
                            months[parseInt(temp[0]) - 1]
                          }-${temp[1].slice(-2)}`;
                        }}
                      />
                      {
                        // console.log('registered users max val ',((parseInt(Math.max(registeredUsers?registeredUsers.reduce((acc,curr)=>{return acc = curr.registeredUsers>acc?curr.registeredUsers:acc},0):50)/10)*10)+ 10))
                      }
                      {/* Math.ceil(parseInt(Math.max(...registeredUsers.registeredUsers ? registeredUsers.map((item) => parseInt(item.registeredUsers)) : [50]) / 10)*10 + 10 ) */}
                      <YAxis
                        style={{ fontSize: "13px" }}
                        stroke="#1E3A5F"
                        orientation="left"
                        domain={[
                          0,
                          parseInt(
                            Math.max(
                              monthlyUtilizationRevenueDataPerUserState
                                ? monthlyUtilizationRevenueDataPerUserState.reduce(
                                    (acc, curr) => {
                                      return (acc =
                                        (curr.creditRevenuePerUser >
                                        curr.utilizationRevenuePerUser
                                          ? curr.creditRevenuePerUser
                                          : curr.utilizationRevenuePerUser) >
                                        acc
                                          ? curr.creditRevenuePerUser >
                                            curr.utilizationRevenuePerUser
                                            ? curr.creditRevenuePerUser
                                            : curr.utilizationRevenuePerUser
                                          : acc);
                                    },
                                    0,
                                  )
                                : 50,
                            ) / 50,
                          ) *
                            50 +
                            50,
                        ]}
                        tickFormatter={(value) => `$ ${value}`}
                      />
                      <Tooltip
                        formatter={(value) => `$${value}`}
                        labelFormatter={(value) => {
                          const temp = value.split("-");
                          return `${temp[0].padStart(2, "0")}-${temp[1]}`;
                        }}
                      />
                      <Legend
                        style={{ fontSize: "12px" }}
                        iconSize={7}
                        iconType="line"
                        formatter={renderFomratter}
                      />
                      <Bar
                        dataKey={"utilizationRevenuePerUser"}
                        name={"Utilization Revenue / User"}
                        //  name={useResponsiveBarName('Uptime Percentage', 'Uptime')}
                        fill="#309f40"
                        activeBar={<Rectangle fill="green" stroke="white" />}
                      />
                      <Bar
                        dataKey={"creditRevenuePerUser"}
                        name={"Credited Revenue / User"}
                        //  name={useResponsiveBarName('Uptime Percentage', 'Uptime')}
                        fill="#FFBB28"
                        activeBar={<Rectangle fill="orange" stroke="white" />}
                      />

                      {/* <Bar name={'Normalised Session Utilisation Ratio'}  fill="#82ca9d" />  */}
                    </BarChart>
                  </ResponsiveContainer>
                )}
              </div>
            </div>

            {/* <div className={`${styles["fourth-row-data-view"]} `}>
              <div
                className={`${styles["data-view"]} ${styles["fourth-row-block-one"]}`}
              >
                
                <div>{totalRegisteredUsers ? totalRegisteredUsers : 0}</div>
                <div className={styles["data-view-headings"]}>
                  Total Registered Users
                </div>
              </div>

              <div
                className={`${styles["data-view"]} ${styles["fourth-row-block-two"]}`}
              >
                
                <div>
                  {usersRegisteredButNeverCharged
                    ? usersRegisteredButNeverCharged
                    : 0}{" "}
                </div>
                <div className={styles["data-view-headings"]}>
                  Total Active Users
                </div>
              </div>
            </div> */}
          </div>

          {/* next field ends */}

          <div
            className={`${styles["row-containers"]} ${styles["fourth-row"]}`}
          >
            <div className={styles["monthly-location-count-div"]}>
              <ResponsiveContainer width="100%" height={250}>
                <div className={styles["graph-view-subheading"]}>
                  Monthly Location Count
                  {(type === "Admin" || type === "Breathe-Admin") && <AntTooltip title="Download All Graphs Data (Excel)" placement="right">
                    <button
                      onClick={() => downloadAllGraphsExcel('Monthly Location Count')}
                      className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                    >
                      <FaDownload />
                    </button>
                  </AntTooltip>}
                </div>

                <LineChart
                  data={monthlyCumulativeLocations}
                  margin={{
                    top: 0,
                    right: 30,
                    left: 0,
                    bottom: 0,
                  }}
                >
                  {/* <CartesianGrid strokeDasharray="3 3" /> */}
                  <XAxis dataKey="_id" />
                  <YAxis />
                  <Tooltip content={<MonthlyLocationsTooltip />} />
                  <Legend />
                  <Line
                    type="monotone"
                    dataKey="monthlyLocations"
                    stroke="#FFBB28d8"
                    activeDot={{ r: 8 }}
                    strokeWidth={4}
                  />
                  <Line
                    type="monotone"
                    dataKey="cumulativeLocations"
                    stroke="#82ca9d"
                    strokeWidth={4}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div
            className={`${styles["row-containers"]} ${styles["fourth-row"]}`}
          >
            <div className={styles["graph-view-fourth"]}>
              <div>
                <ResponsiveContainer width="100%" height={250}>
                  <div className={styles["graph-view-subheading"]}>
                    Monthly Charger Count

                    {(type === "Admin" || type === "Breathe-Admin") && <AntTooltip title="Download All Graphs Data (Excel)" placement="right">
                      <button
                        onClick={() => downloadAllGraphsExcel('Monthly Charger Count')}
                        className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                      >
                        <FaDownload />
                      </button>
                    </AntTooltip>}
                  </div>

                  <LineChart
                    data={monthlyCumulativeCharger}
                    margin={{
                      top: 0,
                      right: 30,
                      left: 0,
                      bottom: 0,
                    }}
                  >
                    {/* <CartesianGrid strokeDasharray="3 3" /> */}
                    <XAxis dataKey="_id" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="monthlyChargers"
                      stroke="#FFBB28d8"
                      activeDot={{ r: 8 }}
                      strokeWidth={4}
                    />
                    <Line
                      type="monotone"
                      dataKey="cumulativeChargers"
                      stroke="#82ca9d"
                      strokeWidth={4}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className={styles["graph-view-fourth"]}>
              <div>
                <ResponsiveContainer width="100%" height={250}>
                  <div className={styles["subheading-with-filter"]}>
                    <div className={styles["graph-view-subheading"]}>
                      Monthly User Count
                      {(type === "Admin" || type === "Breathe-Admin") && <AntTooltip title="Download All Graphs Data (Excel)" placement="right">
                      <button
                        onClick={() => downloadAllGraphsExcel('Monthly User Count')}
                        className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                      >
                        <FaDownload />
                      </button>
                    </AntTooltip>}
                    </div>
                    <div className={styles["loc-selection-usercount"]}>
                      <Select
                        showSearch
                        // defaultValue="Select Location"
                        placeholder="Select Location"
                        // className={styles['ant-select-selection-overflow']}
                        style={{ minWidth: "100%" }}
                        value={userFilterLocationIdState || undefined}
                        onChange={(value) => {
                          setUserFilterLocationIdsState(
                            value === undefined ? [] : value,
                          );
                          // getMonthlyCumulativeUserAndCharger(value)
                          // console.log("set location for report ", value)
                          // setLocationForFilter(value);
                        }}
                        //onSearch={onSearch}
                        allowClear
                        options={locationsData
                          .filter(
                            (element) => element.locationType === "PRIVATE",
                          )
                          .map((element) => ({
                            value: element._id,
                            label: element.locationName,
                          }))}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        // onClear={() => {
                        //   console.log("cleared")
                        //   setUserFilterLocationIdsState([]);
                        // }}

                        size="middle"
                        // maxTagCount={scrolled && showFilters && 1}
                      />
                    </div>
                  </div>

                  <LineChart
                    data={monthlyCumulativeUsers}
                    // margin={{
                    //   top: 5,
                    //   right: 30,
                    //   left: 20,
                    //   bottom: 5
                    // }}
                  >
                    {/* <CartesianGrid strokeDasharray="3 3" /> */}
                    <XAxis dataKey="_id" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="monthlyRegisteredUsers"
                      stroke="#FFBB28d8"
                      activeDot={{ r: 8 }}
                      strokeWidth={4}
                    />
                    <Line
                      type="monotone"
                      dataKey="cumulativeUsers"
                      stroke="#82ca9d"
                      strokeWidth={4}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>

          <div className={`${styles["row-containers"]} ${styles["third-row"]}`}>
            <div className={styles["graph-view"]}>
              <div>
                <ResponsiveContainer width="100%" height={250}>
                  <div className={styles["graph-view-subheading"]}>
                    Registered Users
                    <TooltipView
                      text={
                        <span>
                          This chart displays new user registrations per month.
                          By default, this chart displays new user registrations
                          over the past six months
                          <div>
                            Start Date:{" "}
                            {formatDate(
                              filterFromDate
                                ? filterFromDate
                                : new Date(
                                    new Date().setMonth(
                                      new Date().getMonth() - 6,
                                    ),
                                  ),
                            )}{" "}
                          </div>
                          <div>
                            End Date:{" "}
                            {formatDate(
                              filterToDate ? filterToDate : new Date(),
                            )}
                          </div>
                        </span>
                      }
                    />
                    {(type === "Admin" || type === "Breathe-Admin") && <AntTooltip title="Download All Graphs Data (Excel)" placement="right">
                      <button
                        onClick={() => downloadAllGraphsExcel('Registered Users')}
                        className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                      >
                        <FaDownload />
                      </button>
                    </AntTooltip>}
                  </div>

                  <BarChart
                    data={registeredUsers}
                    margin={{ top: 10, right: 10, left: 15, bottom: 10 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="monthYear"
                      tickFormatter={(value) => {
                        const temp = value.split("-");
                        // console.log('tempvalue',temp);
                        // return `${value.month}-${value.year}`
                        return `${
                          months[parseInt(temp[0]) - 1]
                        }-${temp[1].slice(-2)}`;
                      }}
                      style={{ fontSize: "13px" }}
                    />
                    <YAxis
                      style={{ fontSize: "13px" }}
                      stroke="#1E3A5F"
                      domain={[
                        0,
                        parseInt(
                          Math.max(
                            registeredUsers
                              ? registeredUsers.reduce((acc, curr) => {
                                  return (acc =
                                    curr.registeredUsers > acc
                                      ? curr.registeredUsers
                                      : acc);
                                }, 0)
                              : 50,
                          ) / 25,
                        ) *
                          25 +
                          25,
                      ]}
                      // domain={[0, ((parseInt(Math.max(adminCredits?adminCredits.adminCredits.reduce((acc,curr)=>{return acc = curr.adminCredits>acc?curr.adminCredits:acc},0):50)/10)*10)+ 10)]}
                    />
                    <Tooltip
                      formatter={(value) => ` ${value} `}
                      labelFormatter={(value) => {
                        const temp = value.split("-");
                        return `${temp[0].padStart(2, "0")}-${temp[1]}`;
                      }}
                    />

                    <Bar
                      dataKey="registeredUsers"
                      name="Registered Users"
                      //  name={useResponsiveBarName('Energy Consumption', 'Energy Cons.')}
                      fill="#309f40"
                      activeBar={<Rectangle fill="green" stroke="white" />}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className={styles["graph-view"]}>
              <div>
                <ResponsiveContainer width="100%" height={250}>
                  <div className={styles["graph-view-subheading"]}>
                    Active Users #1
                    <TooltipView
                      text={
                        <span>
                          This chart displays the share of users who completed
                          at least one charging session in a given month,
                          compared to all users who have charged atleast once
                          until the end of that month. By default, it covers the
                          last six months.
                          <div>
                            Start Date:{" "}
                            {formatDate(
                              filterFromDate
                                ? filterFromDate
                                : new Date(
                                    new Date().setMonth(
                                      new Date().getMonth() - 6,
                                    ),
                                  ),
                            )}{" "}
                          </div>
                          <div>
                            End Date:{" "}
                            {formatDate(
                              filterToDate ? filterToDate : new Date(),
                            )}
                          </div>
                        </span>
                      }
                    />
                    {(type === "Admin" || type === "Breathe-Admin") && <AntTooltip title="Download All Graphs Data (Excel)" placement="right">
                      <button
                        onClick={() => downloadAllGraphsExcel('Active Users 1')}
                        className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                      >
                        <FaDownload />
                      </button>
                    </AntTooltip>}
                  </div>

                  <BarChart
                    data={activeUsers}
                    margin={{ top: 10, right: 10, left: 15, bottom: 10 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="monthYear"
                      tickFormatter={(value) => {
                        const temp = value.split("-");
                        // console.log('tempvalue',temp);
                        // return `${value.month}-${value.year}`
                        return `${
                          months[parseInt(temp[0]) - 1]
                        }-${temp[1].slice(-2)}`;
                      }}
                      style={{ fontSize: "13px" }}
                    />
                    <YAxis
                      style={{ fontSize: "13px" }}
                      stroke="#1E3A5F"
                      domain={[0, 100]}
                      tickFormatter={(value) => `${value}%`}
                    />
                    <Tooltip
                      formatter={(value) => `${value} %`}
                      labelFormatter={(value) => {
                        const temp = value.split("-");
                        return `${temp[0].padStart(2, "0")}-${temp[1]}`;
                      }}
                    />

                    <Bar
                      dataKey="activeUsersRatio"
                      name="Active Users Percentage"
                      //  name={useResponsiveBarName('Energy Consumption', 'Energy Cons.')}
                      fill="#309f40"
                      activeBar={<Rectangle fill="green" stroke="white" />}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className={styles["graph-view"]}>
              <div>
                <ResponsiveContainer width="100%" height={250}>
                  <div className={styles["graph-view-subheading"]}>
                    Active Users #2
                    <TooltipView
                      text={
                        <span>
                          This chart displays the share of users who completed
                          at least one charging session in a given month,
                          compared to all users who have registered until the
                          end of that month. By default, it covers the last six
                          months.
                          <div>
                            Start Date:{" "}
                            {formatDate(
                              filterFromDate
                                ? filterFromDate
                                : new Date(
                                    new Date().setMonth(
                                      new Date().getMonth() - 6,
                                    ),
                                  ),
                            )}{" "}
                          </div>
                          <div>
                            End Date:{" "}
                            {formatDate(
                              filterToDate ? filterToDate : new Date(),
                            )}
                          </div>
                        </span>
                      }
                    />
                    {(type === "Admin" || type === "Breathe-Admin") && <AntTooltip title="Download All Graphs Data (Excel)" placement="right">
                        <button
                          onClick={() => downloadAllGraphsExcel('Active Users 2')}
                          className={`${styles["excel-download-graph-btn"]} ${styles["show"]}`}
                        >
                          <FaDownload />
                        </button>
                      </AntTooltip>}
                  </div>

                  <BarChart
                    data={secondaryActiveUsers}
                    margin={{ top: 10, right: 10, left: 15, bottom: 10 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="monthYear"
                      tickFormatter={(value) => {
                        const temp = value.split("-");
                        // console.log('tempvalue',temp);
                        // return `${value.month}-${value.year}`
                        return `${
                          months[parseInt(temp[0]) - 1]
                        }-${temp[1].slice(-2)}`;
                      }}
                      style={{ fontSize: "13px" }}
                    />
                    <YAxis
                      style={{ fontSize: "13px" }}
                      stroke="#1E3A5F"
                      domain={[0, 100]}
                      tickFormatter={(value) => `${value}%`}
                    />
                    <Tooltip
                      formatter={(value) => `${value} %`}
                      labelFormatter={(value) => {
                        const temp = value.split("-");
                        return `${temp[0].padStart(2, "0")}-${temp[1]}`;
                      }}
                    />

                    <Bar
                      dataKey="activeUsersRatio"
                      name="Active Users Percentage"
                      //  name={useResponsiveBarName('Energy Consumption', 'Energy Cons.')}
                      fill="#309f40"
                      activeBar={<Rectangle fill="green" stroke="white" />}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </>
      )}
    </Container>
  );
};

AdminDashboard.propTypes = {
  user: PropTypes.string,
  type: PropTypes.string,
  userGroups: PropTypes.array,
};
const mapStateToProps = (state) => ({
  user: state.auth && state.auth.user ? state.auth.user.firstName : null,
  type: state.auth && state.auth.user ? state.auth.user.type : null,
  userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : [],
});
export default connect(mapStateToProps, {})(AdminDashboard);
